var _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecondStep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320 250",
    style: {
      enableBackground: "new 0 0 320 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.8378,
    y1: 5.0891,
    x2: 164.3021,
    y2: 247.6481
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F699E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DA73D3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M292.459,0H27.97C13.429,0,2.022,11.857,2.49,26.405l6.415,199.548 C9.333,239.264,20.868,250,34.672,250h251.084c13.804,0,25.339-10.736,25.767-24.047l6.415-199.548C318.406,11.857,307,0,292.459,0z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.7447,
    y1: 52.7256,
    x2: 159.302,
    y2: 205.6537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#39C3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#4A4EFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M250.746,177.661H69.651c-10.535,0-19.075-8.54-19.075-19.075V62.71 c0-10.535,8.54-19.075,19.075-19.075h181.095c10.535,0,19.075,8.54,19.075,19.075v95.876 C269.821,169.121,261.281,177.661,250.746,177.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ACF3FF"
    },
    d: "M252.358,93.472c-0.752,1.732,2.318,2.205,0.814,4.032 c-2.851,3.465-8.771-1.764-8.677,5.355c0.125,9.418-27.222,2.11-32.955-1.638c-2.193-1.449-6.453-2.772-8.615-4.189 c-2.663-1.732,3.414-6.489,3.227-8.567c-0.219-2.268-9.116-1.26-1.347-5.26c4.73-2.425,9.523-3.244,14.942-4.599 c7.988-3.433,25.844-2.74,30.824,5.355c1.284,2.079,17.135,1.228,13.658,5.67C262.226,92.181,252.922,92.716,252.358,93.472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00D8E7"
    },
    d: "M250.949,93.315c-1.096,1.354,2.161,2.047,0.752,3.748 c-2.663,3.213-7.612-0.724-8.082,4.977c-0.439,5.701-26.188,1.386-30.605-1.512c-2.036-1.354-3.916-3.496-5.921-4.819 c-2.475-1.606,1.096-5.134,0.908-7.024c-0.188-2.11-6.672-1.921-1.253-4.882c4.323-2.362,8.834-2.992,13.877-4.284 c7.424-3.181,23.995-2.551,28.6,4.977c1.19,1.921,14.128,1.134,10.901,5.26C258.341,92.118,252.765,91.047,250.949,93.315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F1A90F"
    },
    d: "M230.117,79.361c-4.135,0-7.925,0.976-10.807,2.583 c-0.533,0.189-0.877,0.283-0.846,0.315c-4.104,1.575-13.407,4.221-6.39,6.457c7.737,2.488-4.229,5.922,2.725,7.15 c2.068,0.378,2.694,1.417,4.542,2.709c4.73,3.307,5.325,4.315,11.277,1.921c6.39-2.583,11.183,2.488,14.003-5.544 c1.159-3.307,9.962-3.874,7.362-6.993c-2.443-2.898-6.516-4.536-10.525-5.733C238.011,80.18,233.343,79.361,230.117,79.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M209.943,86.07c0.345,0.41,1.002,1.228,2.318,1.228 c6.86,0.032,1.378,4.945,0.658,6.363c0.282,0.315,0.908,0.787,2.068,0.787c6.359-0.063,3.383,1.512,4.542,2.709 c4.072,4.126,5.294,5.607,10.4,1.669c6.422-4.945,12.718,2.898,14.911-5.323c1.316-4.882,6.578-1.134,7.518-5.103 c-0.063-0.157-0.188-0.315-0.345-0.504c-2.443-2.898-6.516-4.536-10.525-5.733c-3.508-2.016-8.176-2.835-11.403-2.835 c-4.135,0-7.925,0.976-10.807,2.583c-0.533,0.189-0.877,0.283-0.846,0.315C215.926,83.235,211.321,84.621,209.943,86.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E1A814"
    },
    d: "M221.064,82.92c3.101,0,5.639,1.354,5.639,2.992 c0,1.669-2.537,2.992-5.639,2.992s-5.639-1.354-5.639-2.992C215.425,84.275,217.962,82.92,221.064,82.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E1A814"
    },
    d: "M228.331,83.739c3.101,0,5.639,1.354,5.639,2.992 c0,1.669-2.537,2.992-5.639,2.992s-5.639-1.354-5.639-2.992C222.693,85.062,225.23,83.739,228.331,83.739z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A65C45"
    },
    points: "212.261,72.306 213.107,73.534 214.485,73.03  214.266,71.518 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M217.305,64.841c3.258-1.827,6.077-3.685,8.834-4.725 c2.475-0.913,4.918-1.323,7.08-1.638c-3.477-0.85-6.422-1.417-8.896-0.567C221.628,58.825,219.466,60.998,217.305,64.841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M217.305,64.841c2.819-2.835,5.513-5.008,8.333-5.985 c2.569-0.882,5.294-0.693,7.863-0.283c-3.477-0.945-6.484-1.512-9.022-0.693C221.722,58.793,219.466,60.998,217.305,64.841z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M233.813,63.959c-0.376,0.504-0.72,1.008-1.096,1.512c-0.846,0.157-1.598,0.126-1.754-0.787 c0.094-0.661,0.188-1.323,0.282-1.953C232.059,63.423,232.936,63.675,233.813,63.959z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_4_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 13,
    height: 13,
    xlinkHref: "3B0D22067287611.jpg",
    transform: "matrix(0.24 0 0 0.24 230.88 62.64)"
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A65C45"
    },
    points: "234.44,62.415 233.437,63.833 231.777,63.108  232.059,61.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M233.312,59.454c1.441,3.244,2.976,6.111,3.665,8.788 c0.658,2.425,0.814,4.788,0.94,6.867c1.096-3.244,1.88-5.985,1.284-8.41C238.575,64.116,236.727,61.88,233.312,59.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M233.312,59.454c2.443,2.929,4.26,5.67,4.918,8.441 c0.595,2.52,0.188,5.071-0.407,7.497c1.159-3.213,1.974-6.048,1.41-8.536C238.638,64.179,236.727,61.88,233.312,59.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M233.25,61.25c3.978,2.173,7.706,3.874,10.525,6.048 c2.537,1.953,4.511,4.189,6.265,6.237c-1.378-4.158-2.725-7.528-5.2-9.544C242.177,61.848,238.575,61.029,233.25,61.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M233.25,61.25c4.73,1.071,8.677,2.425,11.496,4.693 c2.569,2.079,4.135,4.977,5.388,7.906c-1.316-4.189-2.663-7.654-5.169-9.733C242.271,61.88,238.575,61.029,233.25,61.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#69BF2C"
    },
    d: "M235.693,61.281c-4.135-1.827-7.769-3.748-11.183-4.662 c-3.101-0.819-6.077-1.008-8.74-1.165c4.104-1.449,7.581-2.457,10.682-1.701C229.772,54.541,232.623,56.903,235.693,61.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M235.693,61.281c-3.728-3.118-7.205-5.418-10.745-6.268 c-3.195-0.756-6.453-0.22-9.492,0.567c4.104-1.512,7.643-2.583,10.807-1.858C229.678,54.478,232.623,56.903,235.693,61.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M233.156,61.407c4.511,0.441,8.583,0.504,12.029,1.386 c3.101,0.787,5.795,2.079,8.176,3.244c-2.882-3.276-5.451-5.859-8.521-6.709C241.582,58.415,237.948,59.076,233.156,61.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M233.156,61.407c4.761-0.882,8.928-1.197,12.405-0.22 c3.164,0.913,5.733,2.961,8.051,5.134c-2.851-3.339-5.419-6.016-8.552-6.93C241.676,58.415,237.948,59.077,233.156,61.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M235.662,60.777c-4.699-4.252-7.205-10.457-11.841-13.922 C230.368,51.265,234.847,52.966,235.662,60.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M235.411,59.045c-2.819-5.008-7.581-8.568-11.34-12.064 C229.647,50.761,236.194,50.32,235.411,59.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M229.772,57.092c-3.227,3.244-5.075,7.686-7.142,11.245 c4.511-3.276,7.957-5.04,9.554-9.008c-0.501-0.063-1.002-0.094-1.504-0.157C230.743,58.257,230.336,57.596,229.772,57.092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M230.681,59.171c-2.443,3.559-5.325,6.52-8.27,9.418 c4.542-3.307,8.803-5.008,10.431-9.04c-0.345-0.41-1.222-0.693-2.161-0.315C230.681,59.203,230.681,59.171,230.681,59.171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M236.319,61.439c3.822-2.457,6.578-6.426,9.366-9.449 c-5.106,2.236-8.865,3.213-11.215,6.741c0.47,0.157,0.94,0.315,1.41,0.472C235.63,60.116,235.85,60.84,236.319,61.439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M235.849,59.234c3.164-2.961,6.578-5.229,10.056-7.434 c-5.137,2.236-9.68,3.024-12.123,6.615c0.251,0.472,1.034,0.945,2.036,0.756C235.849,59.202,235.849,59.234,235.849,59.234z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M233.312,65.66c-0.407,0.567-0.814,1.102-1.222,1.669c-0.658-0.284-1.66-0.189-2.318-0.472 c0.094-0.724,0.595-1.858,0.689-2.583C231.37,65.03,232.341,65.376,233.312,65.66z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 16,
    height: 14,
    xlinkHref: "3B0D22067287613.jpg",
    transform: "matrix(0.24 0 0 0.24 229.68 64.08)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M232.905,67.297c-0.407,0.693-0.846,1.354-1.253,2.047c-0.877-0.221-1.786-0.472-2.663-0.693 c0.188-0.882,0.501-2.016,0.689-2.898C230.743,66.447,231.746,67.014,232.905,67.297z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_8_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 17,
    height: 16,
    xlinkHref: "3B0D22067287616.jpg",
    transform: "matrix(0.24 0 0 0.24 228.96 65.52)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M232.247,69.282c-0.439,0.724-0.846,2.173-1.316,2.929c-0.846-0.283-1.88-0.756-2.725-1.039l0.595-3.276 C229.804,68.683,230.806,69.219,232.247,69.282z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_10_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 18,
    height: 19,
    xlinkHref: "3B0D22067287617.jpg",
    transform: "matrix(0.24 0 0 0.24 228 67.68)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M231.715,71.424c-0.407,0.85-0.627,1.89-1.034,2.74c-1.284,0.693-2.349,0.535-3.007-0.378 c-0.031-1.008,0.125-2.299,0.313-3.244C228.989,71.361,230.086,71.392,231.715,71.424z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_12_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 18,
    height: 19,
    xlinkHref: "3B0D22067287612.jpg",
    transform: "matrix(0.24 0 0 0.24 227.52 70.32)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M231.151,73.944c-0.407,0.945-0.783,1.89-1.002,3.433c-0.94-0.252-2.13-0.756-3.07-1.008 c-0.031-1.134,0.188-2.394,0.157-3.528C228.425,73.818,229.678,73.912,231.151,73.944z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_14_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 18,
    height: 20,
    xlinkHref: "3B0D2206728761D.jpg",
    transform: "matrix(0.24 0 0 0.24 227.04 72.72)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    d: "M230.806,76.432c-0.345,1.071-0.564,2.394-0.908,3.465c-0.971-0.189-1.911-0.378-2.882-0.536 c-0.125-1.228-0.219-2.457-0.345-3.685C228.081,76.621,229.428,76.715,230.806,76.432z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_16_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 18,
    height: 18,
    xlinkHref: "3B0D2206728761E.jpg",
    transform: "matrix(0.24 0 0 0.24 226.56 75.6)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M230.555,79.33c-0.282,1.165-0.627,2.551-0.658,3.906c-1.002-0.094-2.318-0.063-3.321-0.157 c-0.219-1.26,0.125-3.244-0.063-4.504C227.642,79.235,229.146,79.865,230.555,79.33z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_18_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 18,
    height: 20,
    xlinkHref: "3B0D2206728761F.jpg",
    transform: "matrix(0.24 0 0 0.24 226.32 78.48)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M230.117,82.732c-0.094,1.26-0.031,2.52-0.125,3.811c-0.251,1.102-2.788,0.882-3.101,0 c-0.313-1.323-0.815-2.835-1.128-4.158C227.454,82.889,228.833,83.173,230.117,82.732z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_20_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 19,
    height: 23,
    xlinkHref: "3B0D22067287614.jpg",
    transform: "matrix(0.24 0 0 0.24 225.6 82.32)"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#69BF2C"
    },
    d: "M231.683,57.218c-0.626,6.111,1.222,12.316,2.068,17.765 c1.911-7.276,4.01-12.032,2.318-17.481c-0.564,0.378-1.096,0.756-1.66,1.134C233.625,57.596,232.685,57.25,231.683,57.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M234.346,58.604c0.47,5.796-0.031,11.308-0.626,16.788 c1.942-7.276,4.918-12.725,3.195-18.3c-0.72-0.126-1.848,0.315-2.506,1.512C234.408,58.604,234.377,58.604,234.346,58.604z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M212.763,73.503c0.345,0.378,0.689,0.787,1.065,1.197c0.72,0.094,1.316,0.031,1.347-0.724 c-0.157-0.535-0.282-1.071-0.439-1.606C214.141,72.967,213.452,73.219,212.763,73.503z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_22_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 11,
    height: 11,
    xlinkHref: "888E5EAEE8D9108A.jpg",
    transform: "matrix(0.24 0 0 0.24 212.64 72.24)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_23_",
    d: "M213.389,74.857c0.47,0.346,0.94,0.724,1.378,1.071c0.439-0.378,1.284-0.504,1.723-0.85 c-0.282-0.567-0.94-1.354-1.222-1.921C214.767,73.944,214.078,74.385,213.389,74.857z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_24_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 14,
    height: 13,
    xlinkHref: "888E5EAEE8D9108D.jpg",
    transform: "matrix(0.24 0 0 0.24 213.36 72.96)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    d: "M214.298,76.085c0.564,0.378,1.128,0.724,1.692,1.102c0.564-0.472,1.128-0.945,1.692-1.449 c-0.47-0.598-1.159-1.354-1.629-1.953C215.582,74.731,215.049,75.487,214.298,76.085z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_26_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 16,
    height: 15,
    xlinkHref: "888E5EAEE8D9108E.jpg",
    transform: "matrix(0.24 0 0 0.24 214.08 73.68)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_27_",
    d: "M215.707,77.219c0.689,0.22,1.754,0.945,2.443,1.165c0.345-0.63,0.72-1.449,1.065-2.079l-2.224-1.764 C216.835,75.55,216.522,76.463,215.707,77.219z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_28_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 16,
    height: 17,
    xlinkHref: "888E5EAEE8D9108C.jpg",
    transform: "matrix(0.24 0 0 0.24 215.52 74.4)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_29_",
    d: "M217.18,78.227c0.752,0.283,1.504,0.787,2.224,1.039c1.159-0.315,1.66-1.008,1.472-1.953 c-0.595-0.598-1.441-1.291-2.13-1.764C218.683,76.652,218.088,77.282,217.18,78.227z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_30_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 18,
    height: 17,
    xlinkHref: "888E5EAEE8D9108B.jpg",
    transform: "matrix(0.24 0 0 0.24 216.96 75.36)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_31_",
    d: "M219.028,79.424c0.814,0.346,1.566,0.661,2.631,1.48c0.376-0.693,0.752-1.669,1.128-2.362 c-0.658-0.693-1.535-1.323-2.193-2.016C220.5,77.818,219.842,78.574,219.028,79.424z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_32_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 17,
    height: 20,
    xlinkHref: "888E5EAEE8D91095.jpg",
    transform: "matrix(0.24 0 0 0.24 218.88 76.32)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_33_",
    d: "M220.312,80.149c0.752,0.598,1.535,1.417,2.287,1.984c0.564-0.567,1.096-1.102,1.66-1.669 c-0.533-0.882-1.034-1.795-1.566-2.677C222.223,79.046,221.346,79.739,220.312,80.149z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_34_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 18,
    height: 19,
    xlinkHref: "888E5EAEE8D91096.jpg",
    transform: "matrix(0.24 0 0 0.24 220.08 77.76)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_35_",
    d: "M221.471,81.408c0.626,0.787,1.41,1.732,1.942,2.74c0.721-0.378,1.692-0.787,2.412-1.197 c-0.313-1.008-1.316-2.425-1.629-3.433C223.601,80.401,222.724,81.377,221.471,81.408z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_36_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 19,
    height: 20,
    xlinkHref: "888E5EAEE8D91094.jpg",
    transform: "matrix(0.24 0 0 0.24 221.28 79.44)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_37_",
    d: "M222.348,82.826c0.345,1.008,0.533,2.047,0.877,3.055c0.439,0.851,2.412,0.284,2.506-0.472 c-0.031-1.134,0.063-2.425,0.031-3.528C224.541,82.542,223.476,83.015,222.348,82.826z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_38_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 15,
    height: 21,
    xlinkHref: "888E5EAEE8D9109A.jpg",
    transform: "matrix(0.24 0 0 0.24 222.24 81.84)"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M211.823,70.29c1.817,1.827,3.602,3.339,4.793,4.977 c1.065,1.48,1.786,3.024,2.443,4.41c-0.094-2.488-0.282-4.536-1.316-6.048C216.584,72.022,214.767,70.983,211.823,70.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M211.823,70.29c2.412,1.323,4.354,2.709,5.545,4.41 c1.065,1.543,1.472,3.402,1.692,5.166c-0.063-2.488-0.219-4.599-1.284-6.142C216.647,72.053,214.767,70.983,211.823,70.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M214.642,70.51c-3.195,0.724-6.14,1.134-8.552,2.11 c-2.161,0.85-3.978,2.016-5.607,3.087c1.786-2.614,3.414-4.725,5.513-5.607C208.283,69.124,210.977,69.282,214.642,70.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M214.642,70.51c-3.509-0.22-6.547-0.063-8.959,0.976 c-2.193,0.945-3.884,2.646-5.325,4.441c1.754-2.646,3.383-4.819,5.545-5.764C208.22,69.124,210.977,69.282,214.642,70.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M211.666,71.739c3.133,0.945,6.046,1.575,8.364,2.709 c2.099,1.008,3.822,2.299,5.388,3.465c-1.598-2.74-3.07-4.945-5.106-5.985C218.088,70.825,215.425,70.794,211.666,71.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M211.666,71.739c3.508,0.032,6.516,0.41,8.865,1.606 c2.13,1.102,3.665,2.929,5.012,4.788c-1.566-2.772-3.039-5.04-5.137-6.142C218.182,70.825,215.425,70.794,211.666,71.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M211.603,71.865c3.258-0.378,6.171-0.945,8.771-0.819 c2.318,0.094,4.417,0.598,6.297,1.071c-2.537-1.89-4.762-3.339-7.048-3.496C217.148,68.494,214.673,69.502,211.603,71.865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M211.603,71.865c3.258-1.354,6.171-2.205,8.803-2.016 c2.381,0.157,4.511,1.228,6.484,2.425c-2.506-1.953-4.761-3.433-7.111-3.622C217.211,68.463,214.673,69.502,211.603,71.865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M213.514,71.486c-4.417-1.323-7.957-4.599-12.06-5.449 C207.093,66.919,210.57,66.636,213.514,71.486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M212.825,70.447c-3.415-2.394-7.612-3.244-11.183-4.378 C206.466,66.825,210.632,64.462,212.825,70.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#69BF2C"
    },
    d: "M211.447,74.006c2.193-2.142,4.01-4.252,5.983-5.638 c1.786-1.26,3.602-2.11,5.263-2.835c-2.945,0.063-5.388,0.284-7.174,1.48C213.608,68.305,212.355,70.479,211.447,74.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M211.447,74.006c1.629-2.866,3.289-5.166,5.325-6.552 c1.848-1.26,4.041-1.701,6.171-1.953c-2.945,0.032-5.482,0.189-7.299,1.417C213.639,68.242,212.355,70.479,211.447,74.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M212.512,70.636c-2.6,2.016-5.075,3.685-6.829,5.575 c-1.598,1.701-2.757,3.528-3.759,5.197c0.501-3.15,1.096-5.733,2.631-7.434C206.184,72.117,208.659,71.109,212.512,70.636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M212.512,70.636c-3.258,1.323-5.952,2.74-7.706,4.725 c-1.598,1.795-2.381,4.063-2.945,6.3c0.438-3.15,1.002-5.796,2.569-7.591C206.09,72.148,208.659,71.109,212.512,70.636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#69BF2C"
    },
    d: "M209.818,68.967c-1.629,4.158-1.535,8.851-2.005,12.82 c2.757-4.693,5.169-7.623,5.012-11.78c-0.47,0.157-0.908,0.315-1.378,0.441C211.102,69.597,210.538,69.187,209.818,68.967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M211.415,70.447c-0.814,4.158-2.224,7.906-3.728,11.623 c2.757-4.725,5.921-7.938,5.795-12.158c-0.47-0.22-1.347-0.157-2.036,0.567C211.447,70.478,211.447,70.447,211.415,70.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ACF3FF"
    },
    d: "M253.329,119.899c-0.282,0.567,1.034,1.039,0.47,1.606 c-1.096,1.071-3.947,0.441-4.949,1.071c-4.166,2.646-11.058,0.441-13.564-0.189c-3.853-0.976,1.253-1.795-0.157-2.52 c-1.002-0.693-2.976-0.913-3.477-1.449c-1.786-2.016,3.79-3.937,6.986-4.882c3.039-0.882,11.904-0.535,13.783,2.362 c0.47,0.756,5.263,1.48,3.947,2.866C255.584,119.584,253.517,119.679,253.329,119.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00D8E7"
    },
    d: "M250.823,119.553c-0.376,0.409,0.752,0.693,0.251,1.197 c-0.94,0.945-1.222,0.567-2.851,1.323c-4.981,2.299-16.039-0.472-12.092-1.386c2.099-0.504-2.161-1.575-2.976-2.709 c-0.814-1.102,3.696-2.803,5.795-3.654c3.133-1.228,10.839-0.63,12.499,1.89c0.407,0.63,3.79,1.323,2.663,2.488 C253.423,119.395,251.449,118.891,250.823,119.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F1A90F"
    },
    d: "M247.878,115.71c1.253,0.599,4.26,2.016,2.099,2.52 c-2.349,0.567,0.627,1.323-1.504,1.512c-0.627,0.063-1.754,0.472-2.005,1.102c-0.376,0.819-1.692,1.039-3.508,0.157 c-1.347-0.661-2.694-0.157-4.01-1.039c-0.125-0.063-2.913-1.134-1.88-2.52c1.316-1.732,2.443-1.827,3.665-2.079 C242.208,114.639,247.91,115.71,247.878,115.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M249.632,117.537c-1.848,0.63-0.689,1.953-1.566,1.638 c-2.851-0.945-0.188,3.717-4.73,1.48c-1.347-0.661-2.255-0.441-2.757-0.724c-0.877-0.504,0.407-1.228-3.101-1.858 c-0.783-0.157-0.313-1.543,0.595-2.047c3.634-1.953,5.733-1.417,9.523-0.567C248.003,115.584,251.136,117.001,249.632,117.537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ACF3FF"
    },
    d: "M146.098,79.626c-0.47,0.85,1.754,1.575,0.783,2.457 c-1.817,1.638-6.641,0.693-8.301,1.638c-6.986,4.032-18.576,0.661-22.805-0.315c-6.484-1.48,2.067-2.709-0.282-3.843 c-1.692-1.039-5.012-1.354-5.858-2.205c-2.976-3.055,6.39-5.985,11.747-7.371c5.106-1.354,19.986-0.819,23.15,3.622 c0.814,1.134,8.865,2.236,6.641,4.347C149.889,79.122,146.474,79.279,146.098,79.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00D8E7"
    },
    d: "M141.901,79.09c-0.658,0.598,1.284,1.071,0.439,1.827 c-1.566,1.417-2.036,0.85-4.793,2.016c-8.364,3.496-26.909-0.693-20.299-2.11c3.54-0.756-3.602-2.362-5.012-4.095 c-1.347-1.669,6.234-4.284,9.742-5.512c5.231-1.858,18.231-0.945,20.957,2.866c0.689,0.976,6.359,1.984,4.448,3.78 C146.286,78.838,142.997,78.082,141.901,79.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#57564A"
    },
    d: "M127.93,79.153l-2.663,1.197 c-0.533-2.709-1.096-8.851-1.159-12.064l3.227,2.016C127.93,74.807,131.877,75.909,127.93,79.153z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9BA89E"
    },
    points: "124.108,68.255 127.272,74.869 126.645,74.775  127.084,77.956 126.802,79.657 127.93,79.153 129.59,77.799 129.402,76.066 129.057,73.547 128.619,73.484 127.334,70.271 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#57564A"
    },
    points: "132.628,78.366 127.93,79.153 128.337,74.775  127.334,70.271 130.373,67.751 132.315,72.759 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9BA89E"
    },
    points: "134.07,66.522 130.373,67.751 131.438,71.877  131.469,74.554 132.628,78.366 133.756,77.074 135.072,73.357 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9BA89E"
    },
    points: "137.578,75.058 135.886,76.602 133.756,77.074  134.163,72.948 132.691,70.082 134.069,66.522 136.012,70.806 136.325,73.137 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B8C8BA"
    },
    points: "129.903,65.2 131.814,65.389 132.503,66.145  134.069,66.522 132.691,70.082 131.25,71.09 127.334,70.271 124.108,68.255 122.354,72.539 121.195,73.137 120.224,72.854  120.913,70.964 119.879,70.901 121.508,69.042 123.513,68.192 125.236,66.491 127.836,66.081 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9BA89E"
    },
    points: "122.197,67.53 123.012,79.72 120.161,81.327  120.004,75.153 121.069,68.444 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#57564A"
    },
    points: "125.267,80.35 123.011,79.72 122.166,73.358  122.197,67.53 124.108,68.255 124.985,72.129 125.298,75.373 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#57564A"
    },
    points: "117.843,81.106 116.903,79.342 118.783,66.46  119.722,64.822 120.756,64.979 120.098,67.908 120.568,70.208 119.566,79.122 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#57564A"
    },
    points: "120.161,81.326 117.843,81.106 118.751,72.948  120.067,70.586 120.098,67.908 121.069,68.444 120.036,75.342 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B8C8BA"
    },
    points: "123.638,68.066 122.197,67.53 121.069,68.444  120.098,67.908 120.693,64.948 119.66,64.853 121.884,64.066 126.426,64.286 125.235,66.491 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A05912"
    },
    points: "126.426,64.286 126.959,66.239 125.236,66.491 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#916245"
    },
    points: "128.399,64.223 127.585,66.019 128.869,67.089  129.809,66.459 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E452B"
    },
    d: "M127.648,66.018l1.222,1.008l0.877-0.598l-1.316-2.142L127.648,66.018z M128.838,67.121l-1.316-1.102 l0.877-1.921l0.031,0.063l1.41,2.268L128.838,67.121z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9BA89E"
    },
    points: "128.776,68.633 126.896,68.79 127.084,67.845  126.457,67.625 126.395,65.074 128.4,64.223 128.744,66.459 129.026,66.554 130.31,68.003 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9BA89E"
    },
    points: "125.173,64.632 125.674,68.255 123.763,68.664  124.452,64.758 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#57564A"
    },
    points: "127.053,68.853 125.674,68.255 125.11,66.428  125.173,64.632 126.395,65.073 126.927,66.365 127.084,67.404 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#57564A"
    },
    points: "124.546,70.208 122.197,67.531 122.917,65.893  123.795,65.326 123.826,64.507 124.452,64.759 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9BA89E"
    },
    points: "132.159,62.522 132.472,63.184 131.751,62.9 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#57564A"
    },
    points: "127.804,64.475 128.337,66.459 127.961,66.334  128.211,67.94 128.024,68.727 128.775,68.633 129.809,68.223 129.715,67.341 129.496,66.05 129.214,65.956 128.399,64.223 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#57564A"
    },
    points: "131.783,68.916 128.775,68.633 129.026,66.554  128.4,64.223 130.373,63.404 131.595,66.113 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9BA89E"
    },
    points: "132.754,63.31 130.373,63.404 131.031,65.577  131.062,66.9 131.783,68.916 132.503,68.444 133.38,66.806 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9BA89E"
    },
    points: "132.503,68.444 132.785,66.459 131.845,64.853  132.754,63.31 133.976,65.672 134.195,66.869 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B8C8BA"
    },
    points: "126.802,62.05 132.159,62.522 131.751,62.9  132.754,63.31 130.655,64.003 128.4,64.223 126.395,65.074 125.173,64.633 124.452,64.759 123.826,64.507 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B8C8BA"
    },
    points: "136.137,73.704 137.233,72.885 139.082,72.287  140.742,72.318 140.366,74.082 136.482,74.68 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#57564A"
    },
    points: "136.137,73.704 135.416,76.066 135.166,78.618  139.269,79.153 138.612,76.287 137.797,76.791 138.048,73.799 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9BA89E"
    },
    points: "141.243,78.586 141.995,77.61 140.742,72.318  140.053,73.389 138.862,73.357 138.549,74.46 139.708,78.082 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9BA89E"
    },
    points: "139.27,79.153 141.243,78.586 140.209,75.248  138.988,74.492 138.862,73.358 138.048,73.799 137.797,76.791 138.612,76.287 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ACF3FF"
    },
    d: "M96.449,68.279c-1.723,2.11,2.757,2.331,1.723,3.339 c-1.942,1.921-5.451,0.693-7.236,1.827c-7.456,4.788-21.834,7.056-23.494-0.409c-1.754-7.875-5.325-4.725-7.424-7.087 c-3.195-3.622,6.829-7.087,12.562-8.756c5.451-1.575,24.653-1.354,24.747,4.284c0.031,1.512,9.492,2.646,7.111,5.134 C103.059,68.027,96.825,67.869,96.449,68.279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00D8E7"
    },
    d: "M95.353,68.027c-1.598,1.638,3.508,1.953-5.012,4.851 c-10.118,3.465-22.022,3.591-23.338-2.677c-0.846-4.095-4.166-3.024-5.764-5.229c-1.535-2.11,7.142-5.418,11.215-7.024 c6.015-2.394,20.926-1.228,24.089,3.654c0.814,1.228,7.33,2.52,5.106,4.819C100.397,67.743,96.575,66.767,95.353,68.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F1A90F"
    },
    d: "M70.919,59.711c-2.788,1.323-9.46,4.473-4.699,5.575 c5.263,1.228-1.378,2.929,3.352,3.339c1.41,0.126,3.853,1.071,4.48,2.425c0.814,1.795,3.759,2.299,7.831,0.315 c2.976-1.449,5.983-0.346,8.896-2.299c0.251-0.189,6.484-2.52,4.166-5.575c-2.945-3.843-5.451-4.063-8.176-4.63 C83.574,57.349,70.919,59.711,70.919,59.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M67.066,63.806c4.104,1.417,1.535,4.315,3.508,3.654 c6.328-2.11,0.407,8.252,10.557,3.276c2.976-1.449,5.012-1.008,6.109-1.606c1.974-1.134-0.877-2.709,6.892-4.126 c1.754-0.315,0.72-3.433-1.347-4.536c-8.113-4.315-12.718-3.15-21.145-1.26C70.7,59.459,63.651,62.64,67.066,63.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E1A814"
    },
    d: "M80.035,61.223c3.07,0,5.545,1.323,5.545,2.961 c0,1.638-2.475,2.961-5.545,2.961s-5.545-1.323-5.545-2.961C74.49,62.546,76.965,61.223,80.035,61.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#473F26"
    },
    d: "M81.538,66.452c-2.161,0.378-4.072-0.22-4.448-1.323 c-1.535-2.961-2.036-6.048-1.566-9.292l3.508-0.598l0.595-0.095L81.538,66.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9C8F69"
    },
    d: "M85.297,63.743c0,1.165-1.598,2.331-3.759,2.709l-1.911-11.308 l0.595-0.094l3.508-0.599C85.266,57.349,85.767,60.467,85.297,63.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#595034"
    },
    d: "M79.377,55.553c-1.002,0.158-2.005,0.346-3.007,0.504 c-0.219,3.465,0.626,6.835,2.036,10.205c0.752,0.283,1.754,0.378,2.819,0.221C81.037,62.798,80.473,59.113,79.377,55.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8F8157"
    },
    d: "M80.129,55.427c1.002-0.157,2.005-0.346,3.007-0.504 c1.347,3.181,1.66,6.615,1.41,10.237c-0.595,0.535-1.535,0.976-2.6,1.228C80.912,62.798,80.254,59.176,80.129,55.427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#73694B"
    },
    d: "M78.249,56.341c1.002-0.157,2.005-0.346,3.007-0.504 c1.034,3.402,1.41,6.867,1.66,10.268c-0.47,0.189-0.814,0.283-1.378,0.378c-0.564,0.094-0.971,0.126-1.504,0.094 C79.158,63.208,78.374,59.806,78.249,56.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BB9E68"
    },
    d: "M79.252,52.845c2.255-0.378,4.26,0.284,4.48,1.48 c0.219,1.197-1.472,2.52-3.728,2.898c-2.256,0.378-4.26-0.283-4.48-1.48C75.305,54.514,76.965,53.223,79.252,52.845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#473F26"
    },
    d: "M79.283,53.128c1.974-0.346,3.696,0.252,3.884,1.291 c0.188,1.039-1.284,2.173-3.227,2.488c-1.974,0.346-3.696-0.252-3.884-1.291C75.9,54.609,77.341,53.475,79.283,53.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9C8F69"
    },
    d: "M83.167,54.735c-0.094,0.945-1.472,1.89-3.227,2.205 c-1.786,0.315-3.352-0.126-3.79-1.008c0.094-0.945,1.472-1.89,3.227-2.205C81.162,53.412,82.76,53.853,83.167,54.735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B6CBD8"
    },
    d: "M75.367,58.609c1.284,2.898,8.928,1.638,9.398-1.669 c-0.094-0.283-0.188-0.567-0.282-0.819c-0.94,2.866-7.456,3.969-9.116,1.638C75.367,58.01,75.367,58.294,75.367,58.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#60869D"
    },
    d: "M75.367,58.609c1.284,2.898,8.928,1.638,9.398-1.669 c-0.094-0.252-0.157-0.504-0.251-0.724c-0.877,2.929-7.518,4.032-9.147,1.638C75.367,58.073,75.367,58.357,75.367,58.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B6CBD8"
    },
    d: "M77.059,65.097c2.036,1.449,6.86,0.598,8.27-1.575 c0.063-0.567,0.125-1.134,0.125-1.701c0-0.032-0.031-0.095-0.031-0.126c-0.94,2.866-7.456,3.969-9.116,1.638v0.032 C76.526,63.963,76.777,64.53,77.059,65.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#60869D"
    },
    d: "M77.059,65.097c2.036,1.449,6.86,0.598,8.27-1.575 c0.063-0.567,0.125-1.134,0.125-1.701V61.79c-0.877,2.898-7.393,4-9.084,1.732C76.558,64.058,76.808,64.562,77.059,65.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#73694B"
    },
    d: "M80.881,54.136c0.376-0.063,0.72,0.063,0.752,0.252 c0.031,0.221-0.251,0.441-0.626,0.504c-0.376,0.063-0.721-0.063-0.752-0.252C80.223,54.419,80.505,54.199,80.881,54.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#473F26"
    },
    d: "M81.507,54.483c-0.063,0.126-0.282,0.252-0.501,0.283 c-0.251,0.032-0.47,0-0.595-0.126c-0.031-0.032-0.063-0.063-0.063-0.094c-0.031-0.252-0.063-0.472-0.125-0.724l1.19-0.189 c0.031,0.252,0.094,0.473,0.125,0.724C81.538,54.388,81.538,54.451,81.507,54.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BB9E68"
    },
    d: "M80.755,53.443c0.313-0.063,0.626,0.032,0.658,0.221 c0.031,0.189-0.219,0.346-0.533,0.409c-0.313,0.063-0.626-0.032-0.658-0.22C80.191,53.664,80.442,53.475,80.755,53.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#96AEBE"
    },
    d: "M77.967,59.27c0.157,0.063,0.251,0.252,0.188,0.441 c-0.031,0.189-0.188,0.283-0.313,0.252c-0.157-0.063-0.251-0.252-0.188-0.441C77.685,59.333,77.811,59.207,77.967,59.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#96AEBE"
    },
    d: "M77.059,59.081c0.157,0.063,0.251,0.252,0.188,0.441 c-0.031,0.189-0.188,0.284-0.313,0.252c-0.157-0.063-0.251-0.252-0.188-0.441C76.777,59.144,76.934,59.018,77.059,59.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#96AEBE"
    },
    d: "M78.875,64.877c0.157,0,0.313,0.157,0.345,0.346 c0.031,0.189-0.063,0.346-0.219,0.346c-0.157,0-0.313-0.157-0.345-0.346C78.625,65.034,78.719,64.877,78.875,64.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#96AEBE"
    },
    d: "M77.998,64.688c0.157,0,0.282,0.158,0.313,0.346 c0.031,0.189-0.094,0.346-0.251,0.346c-0.157,0-0.282-0.157-0.313-0.346C77.716,64.845,77.842,64.688,77.998,64.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5DE2FF"
    },
    d: "M196.757,137.67c-16.63,0-37.03-10.878-47.54-24.056 c-0.309-0.373-2.967-4.04-1.36-3.046c6.986,4.289,6.8,7.211,16.815,6.216c2.658-0.249-2.473-8.951-3.4-12.059 c-1.607-5.47,18.855,12.308,21.143,15.416C184.27,122.503,206.649,137.484,196.757,137.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5C7733"
    },
    d: "M159.974,111.936l41.543,21.073 c-1.916,2.238-5.255,3.73-9.211,3.543c-2.164-0.124-9.273-0.249-19.783-6.776c-3.586-2.238-7.666-5.159-10.757-8.392 C160.84,119.768,160.036,114.422,159.974,111.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M170.916,108.33c2.349,1.243,5.069,2.486,7.913,3.792 l1.236,3.419c4.266,2.238,8.655,5.035,12.982,8.081l1.36-0.684c5.44,3.792,6.862,8.392,7.048,10.132c0,0-8.346,2.238-18.422-3.543 l-1.546,0.808c-5.378-2.051-10.077-4.538-12.982-8.081l-1.236-3.295c-2.102-1.616-4.204-3.357-6.306-5.222 C156.697,110.008,167.269,106.403,170.916,108.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AA6C2A"
    },
    d: "M170.916,108.89c2.164,1.181,4.884,2.362,7.542,3.605 l1.175,3.17c4.018,2.113,9.088,5.222,13.23,8.081l1.175-0.622c5.131,3.605,6.182,7.521,6.306,9.138c0,0-6.615,2.051-16.753-3.108 l-1.484,0.746c-5.069-1.927-10.324-4.973-13.106-8.33l-1.113-3.108c-1.978-1.554-4.018-3.046-5.997-4.724 C157.748,110.32,167.454,107.087,170.916,108.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M170.483,109.636c2.164,1.119,4.76,2.3,7.418,3.543l1.175,3.17 c4.018,2.051,8.964,5.159,13.044,7.957l1.175-0.559c4.451,3.108,5.749,6.465,6.12,8.33c-1.855,0.373-7.728,0.932-15.888-3.17 l-1.484,0.746c-5.007-1.927-9.768-4.413-12.55-7.708l-1.113-3.232c-1.978-1.492-4.389-3.295-6.367-5.035 c-0.865-0.746-0.989-1.057-0.742-1.741C163.312,109.76,168.196,108.454,170.483,109.636z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AA6C2A"
    },
    points: "177.902,113.179 179.077,116.349 179.138,116.411  169.494,121.881 168.382,118.649 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AF7430"
    },
    d: "M154.905,101.99l14.033,8.64 c0.247,0.186,0.556-0.373,0.309-0.559l-14.219-8.392c0,0,0,0,0.062,0.062c0-0.062-0.062-0.062-0.124-0.062l-0.062,0.062 c0,0.062,0,0.062,0,0.124C154.905,101.927,154.905,101.99,154.905,101.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AF7430"
    },
    d: "M159.232,85.269l10.077,6.216 c0.247,0.186,0.556-0.373,0.309-0.559l-10.262-5.967c0,0,0,0,0.062,0.062c0-0.062-0.062-0.062-0.124-0.062l-0.062,0.062 c0,0.062,0,0.062,0,0.124C159.232,85.269,159.232,85.269,159.232,85.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E6D08D"
    },
    d: "M159.541,85.455c-0.247,6.776-1.916,14.421-4.018,16.473 l13.662,8.081c0-2.362,0.124-15.54,0.185-18.524C166.032,89.433,163.25,87.569,159.541,85.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#573724"
    },
    d: "M169.432,87.196l-0.247,27.226c0,0.497,0.989,0.497,0.989,0 l-0.247-27.226c0,0.062,0,0.062-0.062,0.124c-0.062,0-0.124,0.062-0.185,0.062c-0.062,0-0.124,0-0.185-0.062 C169.432,87.258,169.432,87.196,169.432,87.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C98E37"
    },
    d: "M169.494,87.072c-0.124,0.062-0.124,0.186,0,0.249 c0.124,0.062,0.247,0.062,0.371,0c0.124-0.062,0.124-0.186,0-0.249c-0.062,0-0.124-0.062-0.185-0.062 C169.618,87.01,169.556,87.072,169.494,87.072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#573724"
    },
    d: "M177.036,85.206l-0.309,35.742c0,0.622,1.36,0.622,1.36,0 l-0.309-35.742c0,0.062-0.062,0.124-0.124,0.124c-0.062,0.062-0.124,0.062-0.247,0.062c-0.062,0-0.185,0-0.247-0.062 C177.098,85.268,177.036,85.268,177.036,85.206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AA6C2A"
    },
    d: "M167.145,111.749l20.772-11.935 c0.247-0.124-0.124-0.746-0.371-0.622l-20.772,11.935c0.062,0,0.124,0,0.185,0c0.062,0.062,0.124,0.124,0.185,0.186 c0.062,0.062,0.062,0.124,0.062,0.249C167.207,111.624,167.207,111.686,167.145,111.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#573724"
    },
    d: "M166.959,111.686c0.124,0.062,0.247,0,0.247-0.124 c0-0.186-0.124-0.373-0.247-0.435c-0.124-0.062-0.247,0-0.247,0.124c0,0.062,0,0.187,0.062,0.249 C166.836,111.624,166.898,111.686,166.959,111.686z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_39_",
    d: "M187.299,100.186c2.411,1.368,4.327,9.759,0.062,16.721c-3.956,0.435-8.037,0.932-15.517,8.827 c1.669-5.346-1.298-10.319-4.018-14.359C174.317,107.646,180.808,103.916,187.299,100.186z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_40_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 100,
    height: 107,
    xlinkHref: "888E5EAEE8D9109D.jpg",
    transform: "matrix(0.24 0 0 0.24 167.76 100.08)"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C98E37"
    },
    d: "M169.185,95.09l17.186-9.884 c0.247-0.124-0.124-0.746-0.371-0.622l-17.186,9.884c0.062,0,0.124,0,0.185,0c0.062,0.062,0.124,0.124,0.185,0.186 c0.062,0.062,0.062,0.124,0.062,0.249C169.247,94.965,169.247,95.027,169.185,95.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#573724"
    },
    d: "M169,95.028c0.124,0.062,0.247,0,0.247-0.124 c0-0.186-0.124-0.373-0.247-0.435c-0.124-0.062-0.247,0-0.247,0.124c0,0.062,0,0.187,0.062,0.249 C168.876,94.966,168.938,95.028,169,95.028z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_41_",
    d: "M185.753,85.454c2.967,2.424,4.018,8.765,0.804,13.924c-2.967,0.311-10.386,3.73-16.939,9.573 c1.236-3.978,2.349-11.313,0.309-14.297C174.687,91.857,180.869,88.189,185.753,85.454z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_42_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 85,
    height: 98,
    xlinkHref: "888E5EAEE8D910B1.jpg",
    transform: "matrix(0.24 0 0 0.24 169.44 85.44)"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C98E37"
    },
    d: "M177.16,85.082c-0.124,0.062-0.124,0.186,0,0.311 c0.124,0.062,0.371,0.062,0.495,0c0.124-0.062,0.124-0.186,0-0.311c-0.062-0.062-0.124-0.062-0.247-0.062 S177.222,85.02,177.16,85.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#573724"
    },
    d: "M190.761,97.079l-0.247,31.702c0,0.559,1.175,0.559,1.175,0 l-0.309-31.702c0,0.062,0,0.062-0.062,0.124c-0.062,0.062-0.124,0.062-0.185,0.062c-0.062,0-0.124,0-0.185-0.062 C190.822,97.203,190.761,97.141,190.761,97.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AF7430"
    },
    d: "M183.775,105.843l15.208-8.703 c0.185-0.124-0.124-0.684-0.309-0.559l-15.208,8.702c0.062,0,0.124,0,0.185,0c0.062,0.062,0.124,0.062,0.124,0.124 c0.062,0.062,0.062,0.124,0.062,0.186C183.898,105.781,183.837,105.843,183.775,105.843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#573724"
    },
    d: "M183.651,105.843c0.124,0.062,0.247,0,0.247-0.124 s-0.124-0.311-0.247-0.373c-0.124-0.062-0.247,0-0.247,0.124c0,0.062,0,0.124,0.062,0.186 C183.527,105.719,183.589,105.781,183.651,105.843z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_43_",
    d: "M198.426,97.327c2.596,2.176,3.524,7.77,0.68,12.37c-2.596,0.311-9.211,3.295-15.022,8.454 c1.113-3.481,2.04-10.008,0.247-12.681C188.659,103.046,194.161,99.814,198.426,97.327z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_44_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 75,
    height: 88,
    xlinkHref: "888E5EAEE8D910B3.jpg",
    transform: "matrix(0.24 0 0 0.24 184.08 97.2)"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AF7430"
    },
    d: "M190.822,97.017c-0.124,0.062-0.124,0.186,0,0.249 c0.124,0.062,0.309,0.062,0.433,0c0.124-0.062,0.124-0.186,0-0.249c-0.062-0.062-0.124-0.062-0.185-0.062 C191.008,96.954,190.884,96.954,190.822,97.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AA6C2A"
    },
    d: "M191.935,129.838l2.782,1.616c0.556,0.311,1.36,0.311,1.916,0 l1.236-0.746c0.556-0.311,0.556-0.808,0-1.119l-2.844-1.616l-3.091,1.368V129.838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDA00"
    },
    d: "M191.935,129.341l2.844,1.616c0.556,0.311,1.36,0.311,1.916,0 l1.236-0.746c0.556-0.311,0.556-0.808,0-1.119l-2.844-1.554L191.935,129.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C98E37"
    },
    d: "M216.601,133.629c-0.062-0.124-0.124-0.124-0.185,0 c-0.062,0.124-0.062,0.249,0,0.373c0.062,0.124,0.124,0.124,0.185,0c0-0.062,0.062-0.124,0.062-0.186 S216.663,133.691,216.601,133.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AF7430"
    },
    d: "M216.54,133.567l-16.011-1.43 c-0.742-0.062-0.865,1.119,0.062,1.181l15.95,0.746c-0.062,0-0.062,0-0.124-0.062c0-0.062-0.062-0.124-0.062-0.186 c0-0.062,0-0.124,0.062-0.187C216.478,133.567,216.478,133.567,216.54,133.567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E30613"
    },
    d: "M176.974,85.517c-1.731-1.865-4.327,0.995-6.615-1.741 c2.658,5.781,3.029,0.622,6.553,4.973C176.851,88.19,176.233,86.636,176.974,85.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AA6C2A"
    },
    d: "M176.233,124.12l4.822,2.797c0.927,0.559,2.411,0.559,3.338,0 l2.164-1.243c0.927-0.559,0.927-1.43,0-1.927l-4.884-2.859l-5.378,2.424L176.233,124.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDA00"
    },
    d: "M176.233,123.249l4.884,2.859c0.927,0.559,2.411,0.559,3.338,0 l2.164-1.243c0.927-0.559,0.927-1.43,0-1.927l-4.884-2.859L176.233,123.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AD702B"
    },
    d: "M181.982,120.576l18.423-10.567 c0.185-0.124-0.124-0.684-0.309-0.559l-18.422,10.629c0.062,0,0.124,0,0.185,0c0.062,0.062,0.124,0.062,0.124,0.124 c0.062,0.062,0.062,0.124,0.062,0.186C182.044,120.514,182.044,120.576,181.982,120.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#573724"
    },
    d: "M181.858,120.577c0.124,0.062,0.247,0,0.247-0.124 c0-0.124-0.124-0.311-0.247-0.373c-0.124-0.062-0.247,0-0.247,0.124c0,0.062,0,0.124,0.062,0.187 C181.735,120.515,181.797,120.577,181.858,120.577z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_45_",
    d: "M199.848,110.381c2.164,1.243,3.833,8.64,0.062,14.794c-3.524,0.373-6.491,2.486-13.724,7.832 c1.484-4.724-1.113-9.138-3.586-12.743C188.35,116.97,194.099,113.676,199.848,110.381z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_46_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 89,
    height: 96,
    xlinkHref: "888E5EAEE8D910B0.jpg",
    transform: "matrix(0.24 0 0 0.24 182.4 110.16)"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E6D08D"
    },
    d: "M195.459,107.647c3.462,9.448,5.564,18.959,5.378,24.181 c2.596-0.87,7.789-1.678,14.837,1.305C206.834,124.43,198.303,111.625,195.459,107.647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ACF3FF"
    },
    d: "M73.605,151.1c1.07,2.34-3.909,3.743-1.722,6.223 c4.049,4.632,14.799,3.135,18.475,5.989c15.497,11.932,36.345,2.948,45.792,1.451c7.446-1.217,4.002-9.031,7.074-10.949 c3.769-2.34,15.078-4.492,15.357-7.253c0.326-3.042-0.838-4.118-11.867-9.499c-6.701-3.275-5.91-5.709-18.149-5.989 c-11.355-4.586-44.396-6.177-51.469,4.679c-1.815,2.761-19.731,4.024-14.752,9.92C65.135,148.995,72.814,150.071,73.605,151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00D8E7"
    },
    d: "M81.144,150.539c1.536,1.825-3.071,2.714-1.07,5.007 c3.769,4.305,4.886,2.808,11.448,6.645c20.011,11.651,57.519,0.328,41.324-3.79c-3.304-0.842,4.235-4.773,7.074-6.551 c3.49-2.152,14.752-2.901,14.985-5.475c0.558-5.381-16.8-14.085-26.2-13.617c-5.072-5.989-43.558-6.691-50.073,3.416 c-1.675,2.574-15.217,4.165-10.61,9.639C70.673,148.901,78.584,147.497,81.144,150.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F1A90F"
    },
    d: "M106.739,132.196c5.398,0,8.051,2.714,11.774,4.82 c0.698,0.234,9.586-1.685,9.54-1.685c5.305,2.059,17.358,5.755,8.237,8.657c-10.052,3.229,3.351,6.598-5.677,8.189 c-2.699,0.468-7.399,2.714-8.563,5.381c-1.536,3.603-7.213,5.054-14.938,1.918c-5.724-2.293-14.287-0.842-17.032-2.901 c-1.257-0.936,2.932-2.386,1.768-5.615c-1.536-4.305-17.312-2.808-9.586-9.078c3.816-3.088,8.47-5.896,13.635-7.44 C100.503,131.869,102.551,132.196,106.739,132.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M135.312,142.49c-4.7,3.135-3.164,5.054-2.234,6.925 c-0.372,0.421-1.21,1.263-2.699,0.983c-17.079-3.275-3.211,15.535-24.245,7.721c-6.143-2.293-10.424-1.076-12.658-2.059 c-4.095-1.825,1.908-1.965-1.815-6.832c-2.234-2.901-11.588-4.586-9.354-7.3c3.164-3.79,6.469-6.925,11.634-8.516 c7.818-4.492,16.195-3.322,23.036,0.468c3.676,2.152,5.538,0.187,8.888,0.608C127.773,134.77,141.641,138.279,135.312,142.49z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E1A814"
    },
    cx: 104.04,
    cy: 140.946,
    rx: 8.377,
    ry: 4.445
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M120.467,108.426c-4.84-2.714-9.028-5.475-13.123-7.019 c-3.676-1.357-7.306-1.965-10.517-2.433c5.166-1.263,9.54-2.106,13.216-0.842C113.998,99.535,117.209,102.717,120.467,108.426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M120.467,108.426c-4.188-4.211-8.19-7.44-12.379-8.891 c-3.816-1.31-7.865-1.029-11.681-0.421c5.166-1.404,9.633-2.246,13.449-1.029C113.905,99.441,117.21,102.717,120.467,108.426z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_47_",
    d: "M95.943,107.115c0.558,0.749,1.07,1.497,1.629,2.246c1.256,0.234,2.373,0.187,2.606-1.17 c-0.14-0.983-0.279-1.965-0.419-2.901C98.549,106.32,97.246,106.741,95.943,107.115z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_48_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 19,
    height: 19,
    xlinkHref: "888E5EAEE8D910BF.jpg",
    transform: "matrix(0.24 0 0 0.24 95.76 105.12)"
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A65C45"
    },
    points: "94.965,104.823 96.501,106.928 98.921,105.852  98.549,103.091 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M96.641,100.471c-2.141,4.82-4.421,9.078-5.445,13.055 c-0.977,3.603-1.21,7.112-1.396,10.201c-1.629-4.82-2.792-8.891-1.908-12.494C88.822,107.349,91.568,104.027,96.641,100.471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M96.64,100.471c-3.63,4.352-6.329,8.423-7.306,12.54 c-0.884,3.743-0.279,7.534,0.605,11.137c-1.722-4.773-2.932-8.984-2.094-12.681C88.776,107.443,91.568,104.027,96.64,100.471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M96.733,103.091c-5.91,3.229-11.448,5.755-15.636,8.984 c-3.769,2.901-6.701,6.223-9.307,9.265c2.048-6.177,4.049-11.183,7.725-14.178C83.47,103.98,88.822,102.763,96.733,103.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M96.733,103.091c-7.027,1.591-12.891,3.603-17.079,6.972 c-3.816,3.088-6.143,7.393-8.004,11.745c1.954-6.223,3.956-11.371,7.678-14.459C83.331,104.027,88.822,102.764,96.733,103.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#69BF2C"
    },
    d: "M93.104,103.138c6.143-2.714,11.541-5.568,16.613-6.925 c4.607-1.217,9.028-1.497,12.984-1.731c-6.096-2.152-11.262-3.65-15.869-2.527C101.899,93.124,97.664,96.634,93.104,103.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M93.104,103.138c5.538-4.632,10.703-8.048,15.962-9.312 c4.747-1.123,9.586-0.328,14.101,0.842c-6.096-2.246-11.355-3.837-16.055-2.761C102.085,93.031,97.664,96.634,93.104,103.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M96.92,103.326c-6.701,0.655-12.751,0.749-17.87,2.059 c-4.607,1.17-8.609,3.088-12.146,4.82c4.281-4.866,8.097-8.703,12.658-9.967C84.401,98.881,89.8,99.91,96.92,103.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M96.92,103.325c-7.074-1.31-13.263-1.778-18.428-0.328 c-4.7,1.357-8.516,4.399-11.96,7.627c4.235-4.96,8.051-8.937,12.704-10.294C84.215,98.88,89.8,99.909,96.92,103.325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M93.15,102.39c6.98-6.317,10.703-15.535,17.591-20.682 C101.015,88.258,94.407,90.785,93.15,102.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M93.522,99.863c4.188-7.44,11.262-12.728,16.846-17.922 C102.132,87.509,92.359,86.901,93.522,99.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M101.899,96.962c4.793,4.82,7.539,11.417,10.61,16.705 c-6.701-4.866-11.82-7.487-14.194-13.383c0.745-0.094,1.489-0.14,2.234-0.234C100.503,98.646,101.061,97.711,101.899,96.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M100.549,100.003c3.63,5.288,7.911,9.686,12.286,13.991 c-6.748-4.913-13.077-7.44-15.497-13.429c0.512-0.608,1.815-1.029,3.211-0.468C100.549,100.049,100.549,100.049,100.549,100.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#499922"
    },
    d: "M92.22,103.372c-5.677-3.65-9.773-9.546-13.914-14.038 c7.585,3.322,13.17,4.773,16.66,10.014c-0.698,0.234-1.396,0.468-2.094,0.702C93.243,101.454,92.871,102.483,92.22,103.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M92.871,100.144c-4.7-4.398-9.773-7.768-14.938-11.043 c7.632,3.322,14.38,4.492,18.01,9.826c-0.372,0.702-1.536,1.404-3.025,1.123C92.871,100.097,92.871,100.097,92.871,100.144z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_49_",
    d: "M96.641,109.689c0.605,0.842,1.21,1.638,1.815,2.48c0.977-0.421,2.466-0.281,3.444-0.702 c-0.14-1.076-0.884-2.761-1.024-3.837C99.572,108.753,98.13,109.221,96.641,109.689z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_50_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 23,
    height: 20,
    xlinkHref: "888E5EAEE8D910B2.jpg",
    transform: "matrix(0.24 0 0 0.24 96.48 107.52)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_51_",
    d: "M97.245,112.075c0.605,1.029,1.256,2.012,1.861,3.041c1.303-0.328,2.653-0.702,3.956-1.029 c-0.279-1.31-0.745-2.995-1.024-4.305C100.456,110.812,98.967,111.654,97.245,112.075z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_52_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 25,
    height: 23,
    xlinkHref: "888E5EAEE8D910B6.jpg",
    transform: "matrix(0.24 0 0 0.24 97.2 109.68)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_53_",
    d: "M98.27,115.024c0.652,1.076,1.303,3.229,1.955,4.352c1.256-0.421,2.792-1.123,4.049-1.544l-0.884-4.866 C101.899,114.135,100.364,114.977,98.27,115.024z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_54_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_53_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_54_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 26,
    height: 28,
    xlinkHref: "888E5EAEE8D910B7.jpg",
    transform: "matrix(0.24 0 0 0.24 98.16 112.8)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_55_",
    d: "M99.014,118.205c0.605,1.263,0.931,2.808,1.536,4.071c1.908,1.029,3.49,0.795,4.467-0.562 c0.047-1.497-0.186-3.416-0.465-4.82C103.063,118.112,101.48,118.158,99.014,118.205z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_56_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_55_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_56_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 26,
    height: 27,
    xlinkHref: "888E5EAEE8D9108F.jpg",
    transform: "matrix(0.24 0 0 0.24 98.88 116.88)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_57_",
    d: "M99.852,121.995c0.605,1.404,1.163,2.807,1.489,5.1c1.396-0.374,3.164-1.123,4.561-1.497 c0.047-1.685-0.279-3.556-0.233-5.241C103.947,121.808,102.086,121.901,99.852,121.995z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_58_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_57_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_58_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 26,
    height: 29,
    xlinkHref: "888E5EAEE8D91089.jpg",
    transform: "matrix(0.24 0 0 0.24 99.84 120.24)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_59_",
    d: "M100.41,125.692c0.512,1.591,0.838,3.556,1.349,5.147c1.443-0.281,2.839-0.562,4.281-0.795 c0.186-1.825,0.326-3.65,0.512-5.475C104.459,125.926,102.411,126.067,100.41,125.692z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_60_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_59_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_60_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 26,
    height: 27,
    xlinkHref: "888E5EAEE8D91088.jpg",
    transform: "matrix(0.24 0 0 0.24 100.32 124.56)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_61_",
    d: "M100.736,129.997c0.419,1.731,0.931,3.79,0.977,5.802c1.489-0.14,3.444-0.094,4.933-0.234 c0.326-1.872-0.186-4.82,0.093-6.691C105.064,129.857,102.83,130.746,100.736,129.997z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_62_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_61_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_62_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 27,
    height: 30,
    xlinkHref: "888E5EAEE8D910D4.jpg",
    transform: "matrix(0.24 0 0 0.24 100.56 128.64)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_63_",
    d: "M101.434,135.004c0.14,1.872,0.046,3.743,0.186,5.662c0.372,1.638,4.142,1.31,4.607,0 c0.465-1.965,1.21-4.211,1.675-6.177C105.343,135.238,103.295,135.706,101.434,135.004z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_64_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_63_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_64_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 28,
    height: 33,
    xlinkHref: "888E5EAEE8D910EB.jpg",
    transform: "matrix(0.24 0 0 0.24 101.28 134.4)"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#69BF2C"
    },
    d: "M99.06,97.148c0.931,9.078-1.815,18.296-3.071,26.391 c-2.839-10.809-5.957-17.875-3.444-25.97c0.838,0.562,1.629,1.123,2.466,1.685C96.175,97.663,97.571,97.195,99.06,97.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#357515"
    },
    d: "M95.105,99.161c-0.698,8.61,0.047,16.799,0.931,24.94 c-2.885-10.809-7.306-18.904-4.747-27.186c1.07-0.187,2.746,0.468,3.723,2.246C95.058,99.208,95.058,99.161,95.105,99.161z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E1A814"
    },
    cx: 118.559,
    cy: 145.673,
    rx: 10.285,
    ry: 5.475
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#47461D"
    },
    points: "135.917,133.038 129.775,136.734 118.606,130.277  124.702,126.58 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#605E2F"
    },
    d: "M118.047,129.201c0,3.509,8.097-1.217,8.097-4.82 L118.047,129.201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4D4C22"
    },
    d: "M128.052,146.889v-1.778l-3.304-1.919v0.796 c1.117,0.655,1.629,1.31,1.629,1.919L128.052,146.889z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#605E2F"
    },
    points: "128.052,146.888 128.052,145.11 128.983,144.549  128.983,146.327 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    points: "124.748,143.145 128.052,145.11 128.983,144.548  125.679,142.583 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#605E2F"
    },
    points: "111.392,145.673 111.392,144.83 112.323,144.316  112.323,145.111 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ADAB6D"
    },
    d: "M109.717,144.736v-1.825l3.304,1.918v0.842 c-1.07-0.608-1.443-0.468-1.629,0.047L109.717,144.736z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#605E2F"
    },
    points: "113.021,145.672 113.021,144.83 113.952,144.268  113.952,145.11 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    points: "109.717,142.911 113.021,144.83 113.952,144.268  110.648,142.35 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ADAB6D"
    },
    d: "M120.886,151.146v-1.778l-3.304-1.919v0.796 c1.117,0.655,1.629,1.31,1.629,1.918L120.886,151.146z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#605E2F"
    },
    points: "120.887,151.147 120.887,149.368 121.864,148.807  121.864,150.585 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    points: "117.582,147.45 120.886,149.368 121.864,148.807  118.513,146.888 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#605E2F"
    },
    points: "128.611,136.033 120.886,140.665 120.886,149.415  128.611,144.736 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    points: "128.983,135.845 120.886,140.665 109.671,134.208  117.815,129.341 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ADAB6D"
    },
    points: "120.886,149.415 120.886,140.665 110.09,134.395  110.09,143.145 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#934428"
    },
    points: "127.494,135.799 120.793,139.823 111.206,134.208  117.908,130.231 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B36A23"
    },
    points: "127.494,135.799 120.793,139.823 117.908,138.139  117.908,130.231 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CA8E25"
    },
    d: "M120.793,139.776l-7.958-4.632 c0.14-0.187,0.326-0.328,0.512-0.515c1.489-1.357,4.933-3.416,6.748-3.182l1.489,0.842c1.35,0.983,3.816,2.901,4.607,4.258 L120.793,139.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M122.468,135.096c-0.279,0.094-0.605-0.187-0.791-0.608 c-0.186-0.421-0.093-0.842,0.14-0.936c0.279-0.094,0.605,0.187,0.791,0.608C122.794,134.582,122.747,135.003,122.468,135.096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M122.375,135.143c-0.279,0.094-0.605-0.187-0.791-0.608 c-0.186-0.421-0.093-0.842,0.14-0.936c0.279-0.094,0.605,0.187,0.791,0.608C122.701,134.628,122.654,135.049,122.375,135.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M122.328,135.05c-0.233,0.094-0.558-0.187-0.698-0.561 c-0.14-0.328-0.093-0.608,0.047-0.749c-0.14,0.14-0.14,0.421,0,0.749C121.817,134.863,122.142,135.097,122.328,135.05 c0.047-0.047,0.093-0.047,0.14-0.094C122.421,135.003,122.375,135.05,122.328,135.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M119.257,137.764c0.047-0.281-0.233-0.608-0.698-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.698,0.749C118.839,138.138,119.211,138.045,119.257,137.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M119.303,137.67c0.047-0.281-0.233-0.608-0.698-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.698,0.749C118.837,138.044,119.256,137.951,119.303,137.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M119.21,137.67c0.047-0.234-0.233-0.562-0.605-0.655 c-0.326-0.094-0.652-0.047-0.745,0.094c0.14-0.14,0.419-0.187,0.698-0.094C118.978,137.155,119.257,137.436,119.21,137.67 c-0.047,0.094-0.047,0.094-0.093,0.14C119.21,137.764,119.21,137.717,119.21,137.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B37C2A"
    },
    d: "M120.328,137.905c0.093-0.281-0.186-0.655-0.558-0.842 c-0.419-0.187-0.838-0.14-0.931,0.14c-0.093,0.281,0.186,0.655,0.558,0.842C119.816,138.233,120.235,138.139,120.328,137.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M120.373,137.811c0.093-0.281-0.186-0.655-0.558-0.842 c-0.419-0.187-0.838-0.14-0.931,0.14c-0.093,0.281,0.186,0.655,0.558,0.842C119.861,138.139,120.28,138.092,120.373,137.811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M120.281,137.765c0.093-0.234-0.14-0.562-0.512-0.749 c-0.326-0.14-0.605-0.14-0.745,0c0.14-0.14,0.419-0.14,0.745,0C120.142,137.25,120.374,137.578,120.281,137.765 c-0.047,0.047-0.047,0.094-0.093,0.14C120.235,137.858,120.281,137.812,120.281,137.765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M121.538,137.062c-0.186-0.234-0.605-0.187-1.024,0.047 c-0.372,0.234-0.558,0.608-0.372,0.842s0.605,0.187,1.024-0.047C121.538,137.67,121.724,137.296,121.538,137.062z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M121.491,137.015c-0.186-0.234-0.605-0.187-1.024,0.047 c-0.372,0.234-0.558,0.608-0.372,0.842c0.186,0.234,0.605,0.187,1.024-0.047C121.491,137.577,121.677,137.202,121.491,137.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M121.444,137.063c-0.14-0.187-0.558-0.187-0.884,0.047 c-0.279,0.187-0.465,0.468-0.419,0.655c0-0.187,0.14-0.421,0.419-0.608C120.886,136.922,121.304,136.876,121.444,137.063 c0.047,0.094,0.047,0.094,0.047,0.14C121.491,137.156,121.444,137.063,121.444,137.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M117.489,135.237c0.279,0.094,0.605-0.187,0.791-0.608 c0.186-0.421,0.093-0.842-0.14-0.936c-0.279-0.094-0.605,0.187-0.791,0.608S117.21,135.143,117.489,135.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M117.582,135.284c0.279,0.094,0.605-0.187,0.791-0.608 c0.186-0.421,0.093-0.842-0.14-0.936c-0.279-0.094-0.605,0.187-0.791,0.608S117.303,135.19,117.582,135.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M117.629,135.191c0.233,0.094,0.558-0.187,0.698-0.562 c0.14-0.328,0.093-0.608-0.047-0.749c0.14,0.14,0.14,0.421,0,0.749C118.141,135.004,117.815,135.238,117.629,135.191 c-0.047-0.047-0.093-0.047-0.14-0.094C117.536,135.144,117.536,135.191,117.629,135.191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M119.397,136.453c0.047-0.281-0.326-0.562-0.745-0.655 c-0.465-0.094-0.838,0.047-0.838,0.328c-0.047,0.281,0.326,0.562,0.745,0.655C118.978,136.921,119.351,136.734,119.397,136.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M119.397,136.36c0.047-0.281-0.326-0.562-0.745-0.655 c-0.465-0.094-0.838,0.047-0.838,0.328c-0.047,0.281,0.326,0.562,0.745,0.655C118.978,136.781,119.397,136.641,119.397,136.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M119.303,136.358c0-0.234-0.279-0.515-0.698-0.608 c-0.326-0.047-0.652,0-0.745,0.187c0.14-0.14,0.372-0.234,0.698-0.14C119.024,135.891,119.303,136.125,119.303,136.358 c-0.047,0.094-0.047,0.094-0.047,0.14C119.303,136.452,119.303,136.405,119.303,136.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M126.564,136.032c0.047-0.281-0.233-0.608-0.698-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.698,0.749C126.145,136.406,126.517,136.265,126.564,136.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M126.61,135.892c0.046-0.281-0.233-0.608-0.698-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.698,0.749C126.191,136.313,126.563,136.173,126.61,135.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M126.517,135.891c0.047-0.234-0.233-0.562-0.605-0.655 c-0.326-0.094-0.652-0.047-0.745,0.094c0.14-0.14,0.419-0.187,0.698-0.094C126.284,135.377,126.564,135.658,126.517,135.891 c-0.047,0.094-0.047,0.094-0.093,0.14C126.517,135.985,126.517,135.938,126.517,135.891z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M126.098,136.453c0.047-0.281-0.326-0.562-0.745-0.655 c-0.465-0.094-0.838,0.047-0.838,0.328c-0.047,0.281,0.326,0.562,0.745,0.655C125.679,136.921,126.051,136.734,126.098,136.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M126.098,136.36c0.047-0.281-0.326-0.562-0.745-0.655 c-0.465-0.094-0.838,0.047-0.838,0.328c-0.047,0.281,0.326,0.562,0.745,0.655C125.726,136.781,126.098,136.641,126.098,136.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M126.051,136.359c0-0.234-0.279-0.515-0.698-0.608 c-0.326-0.047-0.652,0-0.745,0.187c0.14-0.14,0.372-0.234,0.698-0.14C125.725,135.892,126.051,136.126,126.051,136.359 c-0.047,0.094-0.047,0.094-0.047,0.14C126.005,136.453,126.005,136.406,126.051,136.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M125.4,136.407c-0.186-0.234-0.605-0.187-1.024,0.047 c-0.372,0.234-0.558,0.608-0.372,0.842s0.605,0.187,1.024-0.047C125.4,137.015,125.54,136.641,125.4,136.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M125.354,136.313c-0.186-0.234-0.605-0.187-1.024,0.047 c-0.372,0.234-0.558,0.608-0.372,0.842s0.605,0.187,1.024-0.047C125.354,136.921,125.493,136.547,125.354,136.313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M125.261,136.36c-0.14-0.187-0.558-0.187-0.884,0.047 c-0.279,0.187-0.465,0.468-0.419,0.655c0-0.187,0.14-0.421,0.419-0.608C124.702,136.219,125.121,136.219,125.261,136.36 c0.047,0.094,0.047,0.094,0.047,0.14C125.307,136.453,125.307,136.406,125.261,136.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M125.4,135.004c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.562-0.419,0.795c0.14,0.234,0.605,0.234,1.024,0C125.353,135.612,125.539,135.238,125.4,135.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M125.353,134.91c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.561-0.419,0.795c0.14,0.234,0.605,0.234,1.024,0C125.307,135.518,125.493,135.143,125.353,134.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M125.26,134.956c-0.14-0.187-0.558-0.234-0.884,0 c-0.279,0.187-0.465,0.421-0.419,0.608c0-0.187,0.14-0.421,0.419-0.562C124.748,134.769,125.121,134.816,125.26,134.956 c0.047,0.094,0.047,0.094,0.047,0.14C125.307,135.05,125.307,135.003,125.26,134.956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M123.399,137.436c0.047-0.281-0.279-0.608-0.698-0.702 c-0.419-0.14-0.838,0-0.884,0.281c-0.047,0.281,0.279,0.608,0.698,0.702C122.98,137.857,123.399,137.716,123.399,137.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M123.446,137.342c0.047-0.281-0.279-0.608-0.698-0.702 c-0.419-0.094-0.838,0-0.884,0.281c-0.047,0.281,0.279,0.608,0.698,0.702C123.027,137.763,123.399,137.623,123.446,137.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M123.353,137.342c0.047-0.234-0.233-0.515-0.651-0.655 c-0.326-0.094-0.652,0-0.745,0.14c0.14-0.14,0.419-0.187,0.698-0.094C123.073,136.827,123.399,137.108,123.353,137.342 c-0.047,0.094-0.047,0.094-0.047,0.14C123.353,137.436,123.353,137.389,123.353,137.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M123.678,136.22c0.047-0.281-0.233-0.608-0.698-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.698,0.749C123.213,136.594,123.632,136.5,123.678,136.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M123.724,136.126c0.046-0.281-0.233-0.608-0.698-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.698,0.749C123.258,136.5,123.677,136.407,123.724,136.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M123.631,136.079c0.047-0.234-0.233-0.561-0.605-0.655 c-0.326-0.094-0.652-0.047-0.745,0.094c0.14-0.14,0.419-0.187,0.698-0.094C123.398,135.564,123.631,135.892,123.631,136.079 c-0.047,0.094-0.047,0.094-0.093,0.14C123.585,136.173,123.631,136.126,123.631,136.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M117.536,136.267c-0.093-0.281-0.512-0.421-0.977-0.281 c-0.465,0.094-0.745,0.374-0.651,0.655c0.093,0.281,0.512,0.421,0.977,0.281C117.35,136.828,117.629,136.501,117.536,136.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M117.536,136.126c-0.093-0.281-0.512-0.421-0.977-0.281 c-0.465,0.094-0.745,0.374-0.651,0.655c0.093,0.281,0.512,0.421,0.977,0.281C117.35,136.687,117.629,136.406,117.536,136.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M117.443,136.173c-0.093-0.234-0.465-0.374-0.884-0.281 c-0.326,0.094-0.558,0.281-0.605,0.468c0.046-0.187,0.279-0.374,0.605-0.421C116.978,135.845,117.35,135.986,117.443,136.173 c0,0.094,0,0.14,0,0.14C117.443,136.267,117.443,136.22,117.443,136.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M115.534,149.228c0.047-0.281-0.233-0.608-0.698-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.698,0.749C115.069,149.603,115.488,149.462,115.534,149.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M115.581,149.135c0.047-0.281-0.233-0.608-0.698-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.698,0.749C115.116,149.509,115.534,149.368,115.581,149.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M115.488,149.088c0.047-0.234-0.233-0.562-0.605-0.655 c-0.326-0.094-0.652-0.047-0.745,0.094c0.14-0.14,0.419-0.187,0.698-0.094C115.255,148.573,115.488,148.9,115.488,149.088 c-0.047,0.094-0.047,0.094-0.093,0.14C115.441,149.181,115.488,149.134,115.488,149.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M114.511,134.769c0.047-0.281-0.233-0.608-0.698-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.698,0.749C114.045,135.143,114.464,135.05,114.511,134.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M114.557,134.675c0.047-0.281-0.233-0.608-0.698-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.698,0.749C114.092,135.049,114.511,134.956,114.557,134.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M114.464,134.628c0.047-0.234-0.233-0.562-0.605-0.655 c-0.326-0.094-0.652-0.047-0.745,0.094c0.14-0.14,0.419-0.187,0.698-0.094C114.231,134.114,114.464,134.441,114.464,134.628 c-0.047,0.094-0.047,0.094-0.093,0.14C114.418,134.722,114.464,134.675,114.464,134.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M120.653,135.19c0.047-0.281-0.233-0.608-0.698-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.698,0.749C120.188,135.565,120.56,135.424,120.653,135.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M120.699,135.096c0.047-0.281-0.233-0.608-0.698-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.698,0.749C120.234,135.471,120.606,135.33,120.699,135.096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M120.606,135.05c0.047-0.234-0.233-0.562-0.605-0.655 c-0.326-0.094-0.652-0.047-0.745,0.094c0.14-0.14,0.419-0.187,0.698-0.094C120.327,134.535,120.606,134.863,120.606,135.05 c-0.047,0.094-0.047,0.094-0.093,0.14C120.56,135.143,120.606,135.097,120.606,135.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M119.024,132.757c0.047-0.281-0.233-0.608-0.698-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.698,0.749C118.606,133.131,118.978,133.037,119.024,132.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M119.07,132.663c0.047-0.281-0.233-0.608-0.698-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.698,0.749C118.605,133.037,119.023,132.944,119.07,132.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M118.978,132.663c0.047-0.234-0.233-0.562-0.605-0.655 c-0.326-0.094-0.652-0.047-0.745,0.094c0.14-0.14,0.419-0.187,0.698-0.094C118.745,132.148,119.024,132.429,118.978,132.663 c-0.047,0.094-0.047,0.094-0.093,0.14C118.978,132.757,118.978,132.71,118.978,132.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M115.022,133.645c-0.093-0.281-0.512-0.374-0.977-0.281 c-0.465,0.094-0.745,0.421-0.651,0.655c0.093,0.281,0.512,0.374,0.977,0.281C114.836,134.207,115.115,133.879,115.022,133.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M115.022,133.506c-0.093-0.281-0.512-0.374-0.977-0.281 c-0.465,0.094-0.745,0.421-0.651,0.655c0.093,0.281,0.512,0.374,0.977,0.281C114.836,134.067,115.115,133.786,115.022,133.506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M114.929,133.552c-0.093-0.234-0.465-0.374-0.884-0.281 c-0.326,0.094-0.558,0.281-0.605,0.468c0.046-0.187,0.279-0.374,0.558-0.421C114.464,133.224,114.836,133.364,114.929,133.552 c0,0.094,0,0.14,0,0.14C114.976,133.645,114.976,133.598,114.929,133.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M117.768,132.336c-0.093-0.281-0.512-0.374-0.977-0.281 c-0.465,0.094-0.745,0.421-0.651,0.655c0.093,0.281,0.512,0.374,0.977,0.281C117.582,132.898,117.861,132.617,117.768,132.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M117.768,132.243c-0.093-0.281-0.512-0.374-0.977-0.281 c-0.465,0.094-0.745,0.421-0.651,0.655c0.093,0.281,0.512,0.374,0.977,0.281C117.582,132.804,117.861,132.523,117.768,132.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M117.675,132.289c-0.093-0.234-0.465-0.374-0.884-0.281 c-0.326,0.094-0.558,0.281-0.605,0.468c0.046-0.187,0.279-0.374,0.558-0.421C117.21,131.962,117.582,132.102,117.675,132.289 c0,0.094,0,0.14,0,0.14C117.722,132.383,117.722,132.336,117.675,132.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M120.141,131.728c-0.093-0.281-0.512-0.374-0.977-0.281 c-0.465,0.094-0.745,0.421-0.651,0.655c0.093,0.281,0.512,0.374,0.977,0.281C119.955,132.289,120.234,131.962,120.141,131.728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M120.095,131.587c-0.093-0.281-0.512-0.374-0.977-0.281 c-0.465,0.094-0.745,0.421-0.651,0.655c0.093,0.281,0.512,0.374,0.977,0.281C119.909,132.149,120.188,131.868,120.095,131.587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M120.049,131.634c-0.093-0.234-0.465-0.374-0.884-0.281 c-0.326,0.094-0.558,0.281-0.605,0.468c0.046-0.187,0.279-0.374,0.558-0.421C119.537,131.307,119.956,131.447,120.049,131.634 c0,0.094,0,0.14,0,0.14C120.049,131.728,120.049,131.681,120.049,131.634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M114.929,148.479c0.093-0.281,0.512-0.374,0.977-0.281 c0.465,0.094,0.745,0.421,0.651,0.655c-0.093,0.281-0.512,0.374-0.977,0.281C115.115,149.041,114.836,148.76,114.929,148.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M114.93,148.386c0.093-0.281,0.512-0.374,0.977-0.281 c0.465,0.094,0.745,0.421,0.651,0.655c-0.093,0.281-0.512,0.374-0.977,0.281C115.163,148.947,114.837,148.666,114.93,148.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M115.022,148.432c0.093-0.234,0.465-0.374,0.884-0.281 c0.326,0.094,0.558,0.281,0.605,0.468c-0.047-0.187-0.279-0.374-0.558-0.421C115.488,148.105,115.115,148.198,115.022,148.432 c0,0.094,0,0.14,0,0.14C115.022,148.526,115.022,148.479,115.022,148.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M119.024,132.945c0.093-0.281,0.512-0.374,0.977-0.281 c0.465,0.094,0.745,0.421,0.651,0.655c-0.093,0.281-0.512,0.374-0.977,0.281C119.257,133.506,118.931,133.225,119.024,132.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M119.07,132.851c0.093-0.281,0.512-0.374,0.977-0.281 c0.465,0.094,0.745,0.421,0.651,0.655c-0.093,0.281-0.512,0.374-0.977,0.281C119.256,133.412,118.977,133.132,119.07,132.851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M119.117,132.851c0.093-0.234,0.465-0.374,0.884-0.281 c0.326,0.094,0.558,0.281,0.605,0.468c-0.047-0.187-0.279-0.374-0.558-0.421C119.629,132.57,119.21,132.664,119.117,132.851 c0,0.094,0,0.14,0,0.14S119.117,132.945,119.117,132.851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M120.327,135.94c0.093-0.281,0.512-0.374,0.977-0.281 c0.465,0.094,0.745,0.421,0.651,0.655c-0.093,0.281-0.512,0.374-0.977,0.281C120.513,136.501,120.234,136.22,120.327,135.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M120.327,135.846c0.093-0.281,0.512-0.374,0.977-0.281 c0.465,0.094,0.745,0.421,0.651,0.655c-0.093,0.281-0.512,0.374-0.977,0.281C120.514,136.407,120.234,136.127,120.327,135.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M120.421,135.893c0.093-0.234,0.465-0.374,0.884-0.281 c0.326,0.094,0.558,0.281,0.605,0.468c-0.046-0.187-0.279-0.374-0.558-0.421C120.886,135.565,120.514,135.706,120.421,135.893 c0,0.094,0,0.14,0,0.14C120.374,135.986,120.374,135.94,120.421,135.893z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M115.069,135.331c-0.047-0.281,0.279-0.608,0.698-0.749 c0.419-0.14,0.838,0,0.884,0.281c0.047,0.281-0.279,0.608-0.698,0.749C115.488,135.705,115.115,135.611,115.069,135.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M115.022,135.237c-0.047-0.281,0.279-0.608,0.698-0.749 c0.419-0.14,0.838,0,0.884,0.281c0.047,0.281-0.279,0.608-0.698,0.749C115.488,135.611,115.069,135.518,115.022,135.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M115.115,135.19c-0.047-0.234,0.233-0.562,0.605-0.655 c0.326-0.094,0.651-0.047,0.745,0.14c-0.14-0.14-0.419-0.187-0.698-0.094C115.348,134.675,115.069,135.002,115.115,135.19 c0.047,0.094,0.047,0.094,0.093,0.14C115.162,135.283,115.115,135.236,115.115,135.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M112.417,148.853c-0.047-0.281,0.279-0.608,0.698-0.749 c0.419-0.14,0.838,0,0.884,0.281c0.047,0.281-0.279,0.608-0.698,0.749C112.882,149.228,112.463,149.134,112.417,148.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M112.37,148.76c-0.047-0.281,0.279-0.608,0.698-0.749 c0.419-0.14,0.838,0,0.884,0.281c0.047,0.281-0.279,0.608-0.698,0.749C112.835,149.134,112.416,149.04,112.37,148.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M112.463,148.76c-0.047-0.234,0.233-0.562,0.605-0.655 c0.326-0.094,0.651-0.047,0.745,0.14c-0.14-0.14-0.419-0.187-0.698-0.094C112.742,148.245,112.463,148.526,112.463,148.76 c0.047,0.094,0.047,0.094,0.093,0.14C112.509,148.854,112.463,148.807,112.463,148.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M120.7,133.412c-0.047-0.281,0.279-0.608,0.698-0.749 c0.419-0.14,0.838,0,0.884,0.281c0.047,0.281-0.279,0.608-0.698,0.749C121.165,133.787,120.746,133.693,120.7,133.412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M120.653,133.319c-0.047-0.281,0.279-0.608,0.698-0.749 c0.419-0.14,0.838,0,0.884,0.281c0.047,0.281-0.279,0.608-0.698,0.749C121.119,133.693,120.7,133.599,120.653,133.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M120.746,133.271c-0.047-0.234,0.233-0.561,0.605-0.655 c0.326-0.094,0.652-0.047,0.745,0.14c-0.14-0.14-0.419-0.187-0.698-0.094C121.026,132.804,120.746,133.084,120.746,133.271 c0.047,0.094,0.047,0.094,0.093,0.14C120.793,133.365,120.746,133.318,120.746,133.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M122.654,137.109c0.047-0.281-0.326-0.562-0.745-0.655 c-0.465-0.094-0.838,0.047-0.838,0.328c-0.047,0.281,0.326,0.562,0.745,0.655C122.282,137.53,122.654,137.389,122.654,137.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M122.701,137.015c0.047-0.281-0.326-0.562-0.745-0.655 c-0.465-0.094-0.838,0.047-0.838,0.328c-0.047,0.281,0.326,0.562,0.745,0.655C122.282,137.436,122.655,137.296,122.701,137.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M122.608,136.968c0-0.234-0.279-0.515-0.698-0.608 c-0.326-0.047-0.652,0-0.745,0.187c0.14-0.14,0.372-0.234,0.698-0.14C122.282,136.5,122.608,136.781,122.608,136.968 c-0.047,0.094-0.047,0.094-0.047,0.14C122.608,137.061,122.608,137.015,122.608,136.968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M124.097,137.063c-0.186-0.187-0.651-0.14-1.024,0.14 c-0.372,0.281-0.512,0.655-0.326,0.889c0.186,0.187,0.651,0.14,1.024-0.14C124.143,137.624,124.283,137.25,124.097,137.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M124.05,136.969c-0.186-0.187-0.651-0.14-1.024,0.14 c-0.372,0.281-0.512,0.655-0.326,0.889c0.186,0.187,0.652,0.14,1.024-0.14C124.097,137.577,124.237,137.156,124.05,136.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M124.003,137.016c-0.186-0.187-0.558-0.14-0.884,0.094 c-0.279,0.187-0.419,0.468-0.326,0.655c-0.047-0.187,0.093-0.421,0.372-0.655C123.445,136.922,123.817,136.876,124.003,137.016 c0.047,0.094,0.047,0.094,0.047,0.14C124.05,137.11,124.05,137.063,124.003,137.016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M120.653,135.798c-0.186-0.187-0.651-0.14-1.024,0.14 c-0.372,0.281-0.512,0.655-0.326,0.889c0.186,0.187,0.651,0.14,1.024-0.14C120.7,136.407,120.84,136.032,120.653,135.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FEF300"
    },
    d: "M120.607,135.705c-0.186-0.187-0.651-0.14-1.024,0.14 c-0.372,0.281-0.512,0.655-0.326,0.889c0.186,0.187,0.651,0.14,1.024-0.14C120.653,136.313,120.793,135.939,120.607,135.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M120.514,135.751c-0.186-0.187-0.558-0.14-0.884,0.094 c-0.279,0.187-0.419,0.468-0.326,0.655c-0.047-0.187,0.093-0.421,0.372-0.655C119.955,135.705,120.374,135.658,120.514,135.751 c0.047,0.094,0.047,0.094,0.047,0.14C120.56,135.845,120.56,135.798,120.514,135.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M123.864,134.536c-0.186-0.187-0.651-0.14-1.024,0.14 c-0.372,0.281-0.512,0.655-0.326,0.889c0.186,0.187,0.651,0.14,1.024-0.14C123.911,135.144,124.05,134.769,123.864,134.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M123.818,134.489c-0.186-0.187-0.651-0.14-1.024,0.14 c-0.372,0.281-0.512,0.655-0.326,0.889c0.186,0.187,0.651,0.14,1.024-0.094C123.864,135.05,124.004,134.676,123.818,134.489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M123.725,134.535c-0.186-0.187-0.558-0.14-0.884,0.094 c-0.279,0.187-0.419,0.468-0.326,0.655c-0.047-0.187,0.093-0.421,0.372-0.655C123.166,134.442,123.585,134.395,123.725,134.535 c0.047,0.094,0.047,0.094,0.047,0.14C123.818,134.629,123.771,134.582,123.725,134.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B37C2A"
    },
    d: "M121.072,133.551c-0.186-0.187-0.651-0.14-1.024,0.14 c-0.372,0.281-0.512,0.655-0.326,0.889c0.186,0.187,0.652,0.14,1.024-0.14C121.119,134.16,121.258,133.785,121.072,133.551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C700"
    },
    d: "M121.026,133.505c-0.186-0.187-0.651-0.14-1.024,0.14 c-0.372,0.281-0.512,0.655-0.326,0.889c0.186,0.187,0.652,0.14,1.024-0.14C121.072,134.067,121.212,133.692,121.026,133.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M120.933,133.552c-0.186-0.187-0.558-0.14-0.884,0.094 c-0.279,0.187-0.419,0.468-0.326,0.655c-0.047-0.187,0.093-0.421,0.372-0.655C120.374,133.458,120.793,133.412,120.933,133.552 c0.047,0.094,0.047,0.094,0.047,0.14C121.026,133.646,120.979,133.599,120.933,133.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M116.325,133.318c-0.186-0.187-0.651-0.14-1.024,0.14 c-0.372,0.281-0.512,0.655-0.326,0.889c0.186,0.187,0.651,0.14,1.024-0.14C116.372,133.927,116.511,133.505,116.325,133.318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M116.279,133.224c-0.186-0.187-0.651-0.14-1.024,0.14 c-0.372,0.281-0.512,0.655-0.326,0.889c0.186,0.187,0.651,0.14,1.024-0.14C116.325,133.833,116.465,133.458,116.279,133.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M116.186,133.271c-0.186-0.187-0.558-0.14-0.884,0.094 c-0.279,0.187-0.419,0.468-0.326,0.655c-0.047-0.187,0.093-0.421,0.372-0.655C115.627,133.178,116.046,133.131,116.186,133.271 c0.047,0.094,0.047,0.094,0.047,0.14C116.232,133.365,116.232,133.318,116.186,133.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M117.489,135.378c-0.186-0.187-0.651-0.14-1.024,0.14 c-0.372,0.281-0.512,0.655-0.326,0.889c0.186,0.187,0.651,0.14,1.024-0.094C117.535,135.986,117.675,135.565,117.489,135.378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M117.442,135.284c-0.186-0.187-0.651-0.14-1.024,0.14 c-0.372,0.281-0.512,0.655-0.326,0.842c0.186,0.187,0.651,0.14,1.024-0.14C117.489,135.892,117.629,135.518,117.442,135.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M117.349,135.33c-0.186-0.187-0.558-0.14-0.884,0.094 c-0.279,0.187-0.419,0.468-0.326,0.655c-0.047-0.187,0.093-0.421,0.372-0.655C116.837,135.236,117.209,135.19,117.349,135.33 c0.046,0.094,0.047,0.094,0.047,0.14C117.442,135.424,117.395,135.377,117.349,135.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M119.164,132.898c-0.186-0.187-0.651-0.14-1.024,0.14 c-0.372,0.281-0.512,0.655-0.326,0.889c0.186,0.187,0.651,0.14,1.024-0.14C119.211,133.507,119.35,133.132,119.164,132.898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M119.118,132.804c-0.186-0.187-0.651-0.14-1.024,0.14 c-0.372,0.281-0.512,0.655-0.326,0.889c0.186,0.187,0.651,0.14,1.024-0.14C119.118,133.412,119.304,133.038,119.118,132.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M119.025,132.851c-0.186-0.187-0.558-0.14-0.884,0.094 c-0.279,0.187-0.419,0.468-0.326,0.655c-0.047-0.187,0.093-0.421,0.372-0.655C118.466,132.804,118.885,132.757,119.025,132.851 c0.047,0.094,0.047,0.094,0.047,0.14C119.071,132.944,119.071,132.898,119.025,132.851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M115.115,135.331c-0.093-0.281-0.512-0.421-0.931-0.374 c-0.465,0.094-0.745,0.328-0.698,0.608c0.093,0.281,0.512,0.421,0.931,0.374C114.883,135.845,115.162,135.565,115.115,135.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M115.115,135.237c-0.093-0.281-0.512-0.421-0.931-0.374 c-0.465,0.094-0.745,0.328-0.698,0.608c0.093,0.281,0.512,0.421,0.931,0.374C114.883,135.752,115.162,135.471,115.115,135.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M115.022,135.237c-0.047-0.234-0.465-0.374-0.838-0.328 c-0.326,0.047-0.605,0.234-0.605,0.421c0.046-0.187,0.279-0.328,0.605-0.374C114.557,134.91,114.929,135.05,115.022,135.237 c0,0.094,0,0.14,0,0.14C115.022,135.331,115.022,135.284,115.022,135.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M122.236,135.143c-0.093-0.281-0.512-0.421-0.931-0.374 c-0.465,0.094-0.745,0.328-0.698,0.608c0.093,0.281,0.512,0.421,0.931,0.374C122.003,135.658,122.329,135.377,122.236,135.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M122.236,135.003c-0.093-0.281-0.512-0.421-0.931-0.374 c-0.465,0.094-0.745,0.328-0.698,0.608c0.093,0.281,0.512,0.421,0.931,0.374C122.003,135.565,122.329,135.284,122.236,135.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M122.143,135.05c-0.047-0.234-0.465-0.374-0.838-0.328 c-0.326,0.047-0.605,0.234-0.605,0.421c0.046-0.187,0.279-0.328,0.605-0.374C121.677,134.676,122.096,134.816,122.143,135.05 c0,0.094,0,0.14,0,0.14C122.143,135.144,122.143,135.097,122.143,135.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M123.259,133.553c-0.093-0.281-0.512-0.421-0.931-0.374 c-0.465,0.094-0.745,0.328-0.698,0.608c0.093,0.281,0.512,0.421,0.931,0.374C123.027,134.114,123.352,133.834,123.259,133.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M123.259,133.459c-0.093-0.281-0.512-0.421-0.931-0.374 c-0.465,0.094-0.745,0.328-0.698,0.608c0.093,0.281,0.512,0.421,0.931,0.374C123.027,133.974,123.352,133.693,123.259,133.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M123.166,133.459c-0.047-0.234-0.465-0.374-0.838-0.328 c-0.326,0.047-0.605,0.234-0.605,0.421c0.046-0.187,0.279-0.328,0.605-0.374C122.747,133.132,123.119,133.272,123.166,133.459 c0,0.094,0,0.14,0,0.14C123.212,133.553,123.212,133.506,123.166,133.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M117.489,133.88c-0.093-0.281-0.512-0.421-0.931-0.374 c-0.465,0.094-0.745,0.328-0.698,0.608c0.093,0.281,0.512,0.421,0.931,0.374C117.257,134.395,117.582,134.114,117.489,133.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M117.489,133.74c-0.093-0.281-0.512-0.421-0.931-0.374 c-0.465,0.094-0.745,0.328-0.698,0.608c0.093,0.281,0.512,0.421,0.931,0.374C117.257,134.301,117.536,134.02,117.489,133.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M117.396,133.787c-0.047-0.234-0.465-0.374-0.838-0.328 c-0.326,0.047-0.605,0.234-0.605,0.421c0.046-0.187,0.279-0.328,0.605-0.374C116.931,133.412,117.303,133.599,117.396,133.787 c0,0.094,0,0.14,0,0.14C117.396,133.88,117.396,133.833,117.396,133.787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M118.931,131.822c-0.093-0.281-0.512-0.421-0.931-0.374 c-0.465,0.094-0.745,0.328-0.698,0.608c0.093,0.281,0.512,0.421,0.931,0.374C118.699,132.384,119.024,132.103,118.931,131.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M118.931,131.728c-0.093-0.281-0.512-0.421-0.931-0.374 c-0.465,0.094-0.745,0.328-0.698,0.608c0.093,0.281,0.512,0.421,0.931,0.374C118.699,132.243,119.024,131.962,118.931,131.728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M118.838,131.729c-0.047-0.234-0.465-0.374-0.838-0.328 c-0.326,0.047-0.605,0.234-0.605,0.421c0.046-0.187,0.279-0.328,0.605-0.374C118.419,131.401,118.791,131.542,118.838,131.729 c0,0.094,0,0.14,0,0.14C118.838,131.822,118.884,131.776,118.838,131.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M124.655,134.348c0.047-0.281-0.233-0.608-0.651-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.651,0.749C124.19,134.722,124.562,134.628,124.655,134.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FEF300"
    },
    d: "M124.701,134.254c0.047-0.281-0.233-0.608-0.651-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.651,0.749C124.235,134.628,124.608,134.534,124.701,134.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M124.609,134.254c0.047-0.234-0.233-0.562-0.605-0.655 c-0.326-0.094-0.652-0.047-0.745,0.094c0.14-0.14,0.419-0.187,0.698-0.047C124.377,133.739,124.609,134.02,124.609,134.254 c-0.047,0.094-0.047,0.094-0.093,0.14C124.563,134.347,124.609,134.3,124.609,134.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B37C2A"
    },
    d: "M124.33,136.407c0.14-0.234-0.047-0.655-0.465-0.889 c-0.372-0.234-0.791-0.281-0.931,0c-0.14,0.234,0.047,0.655,0.465,0.889C123.771,136.641,124.19,136.641,124.33,136.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAD400"
    },
    d: "M124.423,136.314c0.14-0.234-0.047-0.655-0.465-0.889 c-0.372-0.234-0.791-0.281-0.931,0c-0.14,0.234,0.047,0.655,0.465,0.889C123.864,136.548,124.283,136.548,124.423,136.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M124.329,136.266c0.14-0.234-0.047-0.562-0.419-0.795 c-0.279-0.187-0.605-0.234-0.745-0.094c0.186-0.094,0.465-0.047,0.698,0.14C124.236,135.705,124.422,136.079,124.329,136.266 c-0.047,0.047-0.093,0.094-0.093,0.094C124.283,136.36,124.283,136.313,124.329,136.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M122.701,133.179c0.047-0.281-0.279-0.608-0.745-0.702 c-0.465-0.094-0.838,0.047-0.884,0.328c-0.047,0.281,0.279,0.608,0.745,0.702C122.282,133.6,122.701,133.46,122.701,133.179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M122.747,133.085c0.047-0.281-0.279-0.608-0.745-0.702 c-0.465-0.094-0.838,0.047-0.884,0.328c-0.047,0.281,0.279,0.608,0.745,0.702C122.328,133.506,122.7,133.366,122.747,133.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M122.655,133.085c0.047-0.234-0.279-0.515-0.651-0.608 c-0.326-0.094-0.652,0-0.745,0.187c0.14-0.14,0.419-0.187,0.698-0.14C122.376,132.57,122.655,132.851,122.655,133.085 c-0.047,0.094-0.047,0.094-0.047,0.14C122.655,133.178,122.655,133.131,122.655,133.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M122.329,134.536c-0.046-0.281-0.419-0.515-0.884-0.515 c-0.465,0-0.791,0.234-0.791,0.515c0.046,0.281,0.419,0.515,0.884,0.515C122.003,135.05,122.329,134.816,122.329,134.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FEF300"
    },
    d: "M122.329,134.442c-0.047-0.281-0.419-0.515-0.884-0.515 c-0.465,0-0.791,0.234-0.791,0.515c0.046,0.281,0.419,0.515,0.884,0.515C122.003,134.956,122.375,134.722,122.329,134.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M122.236,134.442c-0.047-0.234-0.372-0.468-0.791-0.421 c-0.326,0-0.605,0.14-0.698,0.328c0.093-0.187,0.326-0.281,0.651-0.281C121.817,134.021,122.189,134.208,122.236,134.442 c0,0.094,0,0.14-0.047,0.14C122.236,134.536,122.236,134.489,122.236,134.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M119.676,134.582c0.14-0.234-0.047-0.655-0.465-0.889 c-0.372-0.281-0.791-0.281-0.931,0c-0.14,0.234,0.047,0.655,0.465,0.889C119.164,134.816,119.583,134.816,119.676,134.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FEF300"
    },
    d: "M119.769,134.488c0.14-0.234-0.047-0.655-0.465-0.889 c-0.372-0.234-0.791-0.281-0.931,0c-0.14,0.234,0.047,0.655,0.465,0.889C119.211,134.722,119.629,134.722,119.769,134.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M119.676,134.441c0.14-0.234-0.047-0.561-0.419-0.795 c-0.279-0.187-0.605-0.234-0.745-0.094c0.186-0.094,0.465-0.047,0.698,0.14C119.583,133.88,119.769,134.254,119.676,134.441 c-0.047,0.047-0.093,0.094-0.093,0.094C119.629,134.535,119.676,134.488,119.676,134.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M122.329,137.764c0.047-0.281-0.279-0.608-0.745-0.702 c-0.419-0.094-0.838,0-0.884,0.281c-0.047,0.281,0.279,0.608,0.745,0.702C121.91,138.185,122.282,138.044,122.329,137.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAD400"
    },
    d: "M122.376,137.67c0.047-0.281-0.279-0.608-0.745-0.702 c-0.419-0.094-0.838,0-0.884,0.281c-0.047,0.281,0.279,0.608,0.745,0.702C121.957,138.091,122.329,137.951,122.376,137.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M122.283,137.669c0.047-0.234-0.233-0.515-0.651-0.608 c-0.326-0.094-0.652,0-0.745,0.14c0.14-0.14,0.419-0.187,0.698-0.14C122.003,137.155,122.283,137.435,122.283,137.669 c-0.047,0.094-0.047,0.094-0.047,0.14C122.236,137.763,122.283,137.716,122.283,137.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B37C2A"
    },
    d: "M115.814,132.711c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C115.814,133.319,116,132.945,115.814,132.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBD900"
    },
    d: "M115.767,132.617c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C115.767,133.225,115.953,132.851,115.767,132.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M115.72,132.663c-0.14-0.187-0.558-0.187-0.884,0 c-0.279,0.187-0.465,0.421-0.419,0.655c0-0.187,0.14-0.421,0.419-0.608c0.372-0.187,0.745-0.187,0.884,0 c0,0.047,0.047,0.047,0.047,0.094C115.767,132.757,115.72,132.71,115.72,132.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M114.045,134.208c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C113.999,134.816,114.185,134.442,114.045,134.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBDB00"
    },
    d: "M113.999,134.114c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C113.952,134.723,114.138,134.348,113.999,134.114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M113.905,134.161c-0.14-0.187-0.558-0.187-0.884,0 c-0.279,0.187-0.465,0.421-0.419,0.655c0-0.187,0.14-0.421,0.419-0.608C113.347,134.02,113.766,134.02,113.905,134.161 c0.047,0.094,0.047,0.094,0.047,0.14C113.952,134.254,113.952,134.208,113.905,134.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M116.046,135.237c-0.093-0.281-0.512-0.374-0.977-0.281 c-0.465,0.094-0.745,0.421-0.651,0.655c0.093,0.281,0.512,0.374,0.977,0.281C115.86,135.799,116.139,135.518,116.046,135.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M116.046,135.144c-0.093-0.281-0.512-0.374-0.977-0.281 c-0.465,0.094-0.745,0.421-0.651,0.655c0.093,0.281,0.512,0.374,0.977,0.281C115.86,135.705,116.139,135.424,116.046,135.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M115.953,135.191c-0.093-0.234-0.465-0.374-0.884-0.281 c-0.326,0.094-0.558,0.281-0.605,0.468c0.046-0.187,0.279-0.374,0.558-0.421C115.488,134.863,115.86,135.003,115.953,135.191 c0,0.094,0,0.14,0,0.14C116,135.284,116,135.237,115.953,135.191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M119.676,135.004c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C119.63,135.565,119.816,135.191,119.676,135.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M119.63,134.91c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C119.583,135.471,119.769,135.097,119.63,134.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M119.536,134.956c-0.14-0.187-0.558-0.187-0.884,0 c-0.279,0.187-0.465,0.421-0.419,0.655c0-0.187,0.14-0.421,0.419-0.608c0.372-0.187,0.745-0.187,0.884,0 c0,0.047,0.047,0.047,0.047,0.094C119.583,135.05,119.583,134.956,119.536,134.956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M117.581,134.067c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C117.535,134.629,117.721,134.301,117.581,134.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M117.535,133.974c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C117.489,134.535,117.675,134.207,117.535,133.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M117.442,134.02c-0.14-0.187-0.558-0.187-0.884,0 c-0.279,0.187-0.465,0.421-0.419,0.655c0-0.187,0.14-0.421,0.419-0.608C116.93,133.833,117.302,133.833,117.442,134.02 c0.047,0.094,0.047,0.094,0.047,0.14C117.488,134.114,117.488,134.067,117.442,134.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M118.513,136.266c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C118.513,136.875,118.699,136.5,118.513,136.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBD900"
    },
    d: "M118.466,136.172c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C118.466,136.781,118.652,136.406,118.466,136.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M118.419,136.219c-0.14-0.187-0.558-0.187-0.884,0 c-0.279,0.187-0.465,0.421-0.419,0.655c0-0.187,0.14-0.421,0.419-0.608C117.861,136.079,118.28,136.079,118.419,136.219 c0.047,0.094,0.047,0.094,0.047,0.14C118.466,136.313,118.419,136.266,118.419,136.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M121.91,138.607c-0.047-0.281-0.419-0.515-0.884-0.468 c-0.465,0-0.791,0.234-0.745,0.515c0.046,0.281,0.419,0.515,0.884,0.468C121.584,139.122,121.91,138.888,121.91,138.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAD400"
    },
    d: "M121.91,138.513c-0.047-0.281-0.419-0.515-0.884-0.468 c-0.465,0-0.791,0.234-0.745,0.515c0.046,0.281,0.419,0.515,0.884,0.468C121.584,139.028,121.956,138.794,121.91,138.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M121.817,138.513c-0.047-0.234-0.372-0.421-0.791-0.421 c-0.326,0-0.605,0.14-0.651,0.374c0.093-0.187,0.326-0.281,0.651-0.328C121.398,138.139,121.77,138.326,121.817,138.513 c0,0.094,0,0.14-0.047,0.14C121.817,138.607,121.817,138.56,121.817,138.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M120.002,137.483c-0.233-0.14-0.651,0-0.977,0.328 c-0.326,0.328-0.372,0.749-0.14,0.936c0.233,0.14,0.652,0,0.977-0.328C120.188,138.045,120.235,137.67,120.002,137.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FEF300"
    },
    d: "M119.955,137.39c-0.233-0.14-0.651,0-0.977,0.328 c-0.326,0.328-0.372,0.749-0.14,0.936c0.233,0.14,0.652,0,0.977-0.328C120.095,137.998,120.188,137.577,119.955,137.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M119.909,137.482c-0.186-0.14-0.605,0-0.838,0.281 c-0.233,0.281-0.326,0.562-0.186,0.749c-0.093-0.187,0-0.468,0.233-0.702C119.304,137.482,119.722,137.389,119.909,137.482 c0.047,0.047,0.093,0.094,0.093,0.14C119.955,137.529,119.909,137.529,119.909,137.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M121.165,132.196c0.047-0.281-0.279-0.608-0.745-0.702 c-0.465-0.094-0.838,0.047-0.884,0.328c-0.047,0.281,0.279,0.608,0.745,0.702C120.747,132.617,121.119,132.476,121.165,132.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M121.211,132.102c0.046-0.281-0.279-0.608-0.745-0.702 c-0.465-0.094-0.838,0.047-0.884,0.328c-0.047,0.281,0.279,0.608,0.745,0.702C120.792,132.523,121.165,132.383,121.211,132.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M121.119,132.101c0.047-0.234-0.279-0.515-0.651-0.608 c-0.326-0.094-0.652,0-0.745,0.187c0.14-0.14,0.419-0.234,0.698-0.14C120.793,131.587,121.119,131.867,121.119,132.101 c-0.047,0.094-0.047,0.094-0.047,0.14C121.072,132.195,121.119,132.148,121.119,132.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B37C2A"
    },
    d: "M121.165,133.366c0.14-0.234-0.047-0.655-0.465-0.889 c-0.372-0.234-0.791-0.281-0.931,0c-0.14,0.234,0.047,0.655,0.465,0.889C120.607,133.6,121.025,133.6,121.165,133.366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C600"
    },
    d: "M121.211,133.272c0.14-0.234-0.047-0.655-0.465-0.889 c-0.372-0.234-0.791-0.281-0.931,0c-0.14,0.234,0.047,0.655,0.465,0.889C120.652,133.506,121.071,133.553,121.211,133.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M121.118,133.225c0.14-0.234-0.047-0.562-0.419-0.795 c-0.279-0.187-0.605-0.234-0.745-0.094c0.186-0.094,0.465-0.047,0.698,0.14C121.025,132.663,121.211,133.037,121.118,133.225 c-0.047,0.047-0.093,0.094-0.093,0.094C121.072,133.318,121.118,133.271,121.118,133.225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B37C2A"
    },
    d: "M118.885,134.91c-0.093-0.281-0.512-0.421-0.931-0.374 c-0.465,0.094-0.745,0.328-0.698,0.608c0.093,0.281,0.512,0.421,0.931,0.374C118.652,135.472,118.931,135.191,118.885,134.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBDB00"
    },
    d: "M118.838,134.816c-0.093-0.281-0.512-0.421-0.931-0.374 c-0.465,0.094-0.745,0.328-0.698,0.608c0.093,0.281,0.512,0.421,0.931,0.374C118.605,135.331,118.931,135.05,118.838,134.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M118.792,134.816c-0.047-0.234-0.465-0.374-0.838-0.328 c-0.326,0.047-0.605,0.234-0.605,0.421c0.046-0.187,0.279-0.328,0.605-0.374C118.327,134.488,118.699,134.629,118.792,134.816 c0,0.094,0,0.14,0,0.14C118.792,134.909,118.792,134.863,118.792,134.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B37C2A"
    },
    d: "M116.139,135.985c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C116.093,136.547,116.279,136.173,116.139,135.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBD900"
    },
    d: "M116.093,135.892c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C116.046,136.453,116.279,136.079,116.093,135.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M116,135.939c-0.14-0.187-0.558-0.187-0.884,0 c-0.279,0.187-0.465,0.421-0.419,0.655c0-0.187,0.14-0.421,0.419-0.608C115.488,135.751,115.86,135.751,116,135.939 c0.047,0.094,0.047,0.094,0.047,0.14C116.046,136.032,116.046,135.939,116,135.939z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B37C2A"
    },
    d: "M122.096,136.548c0.14-0.234-0.047-0.655-0.465-0.889 c-0.372-0.234-0.791-0.281-0.931,0c-0.14,0.234,0.047,0.655,0.465,0.889C121.538,136.782,121.956,136.782,122.096,136.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBDB00"
    },
    d: "M122.143,136.454c0.14-0.234-0.047-0.655-0.465-0.889 c-0.372-0.234-0.791-0.281-0.931,0c-0.14,0.234,0.047,0.655,0.465,0.889C121.631,136.735,122.05,136.735,122.143,136.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M122.096,136.407c0.14-0.234-0.047-0.561-0.419-0.795 c-0.279-0.187-0.605-0.234-0.745-0.094c0.186-0.094,0.465-0.047,0.698,0.14C122.003,135.893,122.142,136.22,122.096,136.407 c-0.047,0.047-0.093,0.094-0.093,0.094S122.049,136.454,122.096,136.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M125.958,135.659c0.14-0.234-0.047-0.655-0.465-0.889 c-0.372-0.281-0.791-0.281-0.931,0c-0.14,0.234,0.047,0.655,0.465,0.889C125.4,135.893,125.819,135.893,125.958,135.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAD400"
    },
    d: "M126.005,135.565c0.14-0.234-0.047-0.655-0.465-0.889 c-0.372-0.234-0.791-0.281-0.931,0c-0.14,0.234,0.047,0.655,0.465,0.889C125.446,135.799,125.865,135.799,126.005,135.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M125.912,135.518c0.14-0.234-0.047-0.561-0.419-0.795 c-0.279-0.187-0.605-0.234-0.745-0.094c0.186-0.094,0.465-0.047,0.698,0.14C125.818,134.957,126.005,135.331,125.912,135.518 c-0.047,0.047-0.093,0.094-0.093,0.094C125.865,135.612,125.912,135.565,125.912,135.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B98326"
    },
    d: "M119.909,132.476c-0.047-0.281-0.419-0.515-0.884-0.468 c-0.465,0-0.791,0.234-0.745,0.515c0.046,0.281,0.419,0.515,0.884,0.468C119.583,132.991,119.956,132.757,119.909,132.476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBDB00"
    },
    d: "M119.909,132.382c-0.047-0.281-0.419-0.515-0.884-0.468 c-0.465,0-0.791,0.234-0.745,0.515c0.046,0.281,0.419,0.515,0.884,0.468C119.583,132.85,119.956,132.616,119.909,132.382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M119.816,132.382c-0.047-0.234-0.372-0.421-0.791-0.421 c-0.326,0-0.605,0.14-0.651,0.374c0.093-0.187,0.326-0.281,0.651-0.328C119.397,131.96,119.769,132.148,119.816,132.382 c0,0.094,0,0.14-0.047,0.14C119.816,132.475,119.816,132.428,119.816,132.382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M117.303,132.149c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C117.256,132.757,117.489,132.383,117.303,132.149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M117.256,132.055c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C117.256,132.664,117.442,132.289,117.256,132.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M117.164,132.102c-0.14-0.187-0.558-0.187-0.884,0 c-0.279,0.187-0.465,0.421-0.419,0.655c0-0.187,0.14-0.421,0.419-0.608c0.372-0.187,0.745-0.187,0.884,0 c0,0.047,0.047,0.047,0.047,0.094C117.257,132.196,117.21,132.149,117.164,132.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B37C2A"
    },
    d: "M117.722,132.617c-0.233-0.14-0.652,0-0.931,0.374 c-0.279,0.374-0.326,0.749-0.093,0.936c0.233,0.14,0.651,0,0.931-0.374C117.862,133.179,117.908,132.758,117.722,132.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBDB00"
    },
    d: "M117.629,132.523c-0.233-0.14-0.652,0-0.931,0.374 c-0.279,0.374-0.326,0.749-0.093,0.936c0.233,0.14,0.651,0,0.931-0.374C117.815,133.132,117.861,132.711,117.629,132.523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M117.582,132.617c-0.186-0.14-0.605,0-0.838,0.328 c-0.233,0.281-0.279,0.562-0.186,0.749c-0.093-0.187,0-0.468,0.186-0.702C117.024,132.663,117.396,132.523,117.582,132.617 c0.047,0.047,0.093,0.094,0.093,0.14C117.628,132.663,117.628,132.663,117.582,132.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M115.395,134.162c-0.093-0.281-0.512-0.374-0.977-0.281 c-0.465,0.094-0.745,0.421-0.651,0.655c0.093,0.281,0.512,0.374,0.977,0.281C115.162,134.723,115.488,134.396,115.395,134.162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M115.348,134.068c-0.093-0.281-0.512-0.374-0.977-0.281 c-0.465,0.094-0.745,0.421-0.651,0.655c0.093,0.281,0.512,0.374,0.977,0.281C115.162,134.629,115.441,134.302,115.348,134.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M115.255,134.068c-0.093-0.234-0.465-0.374-0.884-0.281 c-0.326,0.094-0.558,0.281-0.605,0.468c0.046-0.187,0.279-0.374,0.558-0.421C114.79,133.787,115.209,133.881,115.255,134.068 c0,0.094,0,0.14,0,0.14C115.302,134.161,115.302,134.115,115.255,134.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M111.16,148.292c0.093-0.281,0.512-0.421,0.977-0.328 c0.465,0.094,0.745,0.374,0.651,0.655c-0.093,0.281-0.512,0.421-0.977,0.328C111.393,148.854,111.067,148.573,111.16,148.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M111.16,148.198c0.093-0.281,0.512-0.421,0.977-0.328 c0.465,0.094,0.745,0.374,0.651,0.655c-0.093,0.281-0.512,0.421-0.977,0.328C111.393,148.713,111.067,148.432,111.16,148.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M111.253,148.198c0.093-0.234,0.465-0.374,0.838-0.281 c0.326,0.047,0.558,0.281,0.605,0.468c-0.047-0.187-0.279-0.374-0.605-0.421C111.719,147.871,111.346,148.011,111.253,148.198 c0,0.094,0,0.14,0,0.14C111.253,148.292,111.253,148.245,111.253,148.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M116.884,149.789c0.046-0.281-0.233-0.608-0.698-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.698,0.749C116.465,150.21,116.838,150.07,116.884,149.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M116.93,149.696c0.046-0.281-0.233-0.608-0.698-0.749 c-0.419-0.14-0.838-0.047-0.884,0.234c-0.047,0.281,0.233,0.608,0.698,0.749C116.511,150.117,116.883,149.977,116.93,149.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFCC00"
    },
    d: "M116.884,149.696c0.047-0.234-0.233-0.562-0.605-0.655 c-0.326-0.094-0.652-0.047-0.745,0.094c0.14-0.14,0.419-0.187,0.698-0.094C116.605,149.181,116.884,149.462,116.884,149.696 c-0.047,0.094-0.047,0.094-0.093,0.14C116.837,149.789,116.837,149.742,116.884,149.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M115.907,149.462c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C115.907,150.024,116.093,149.649,115.907,149.462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M115.86,149.368c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C115.86,149.93,116.047,149.555,115.86,149.368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M115.814,149.368c-0.14-0.187-0.558-0.187-0.884,0 c-0.279,0.187-0.465,0.421-0.419,0.655c0-0.187,0.14-0.421,0.419-0.608C115.255,149.228,115.674,149.228,115.814,149.368 c0.047,0.094,0.046,0.094,0.046,0.14C115.86,149.462,115.814,149.415,115.814,149.368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M114.091,147.637c-0.093-0.281-0.512-0.421-0.931-0.374 c-0.465,0.047-0.745,0.328-0.698,0.608c0.093,0.281,0.512,0.421,0.931,0.374C113.859,148.199,114.138,147.918,114.091,147.637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M114.091,147.544c-0.093-0.281-0.512-0.421-0.931-0.374 c-0.465,0.047-0.745,0.328-0.698,0.608c0.047,0.281,0.512,0.421,0.931,0.374C113.859,148.105,114.138,147.825,114.091,147.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M113.998,147.543c-0.047-0.234-0.419-0.374-0.838-0.328 c-0.326,0.047-0.605,0.234-0.605,0.421c0.046-0.187,0.279-0.328,0.605-0.374C113.533,147.216,113.905,147.356,113.998,147.543 c0,0.094,0,0.14,0,0.14S113.998,147.637,113.998,147.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M115.395,148.713c0.047-0.281-0.326-0.562-0.745-0.655 c-0.465-0.094-0.838,0.047-0.838,0.328c-0.047,0.281,0.326,0.562,0.745,0.655C114.976,149.135,115.348,148.994,115.395,148.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8C300"
    },
    d: "M115.395,148.62c0.047-0.281-0.326-0.562-0.745-0.655 c-0.465-0.094-0.838,0.047-0.838,0.328c-0.047,0.281,0.326,0.562,0.745,0.655C114.976,149.041,115.395,148.9,115.395,148.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M115.302,148.573c0-0.234-0.279-0.515-0.698-0.608 c-0.326-0.047-0.652,0-0.745,0.187c0.14-0.14,0.372-0.234,0.698-0.14C115.023,148.105,115.302,148.385,115.302,148.573 c-0.047,0.094-0.047,0.094-0.047,0.14C115.302,148.713,115.302,148.666,115.302,148.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M114.557,148.573c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C114.557,149.182,114.744,148.807,114.557,148.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FEF300"
    },
    d: "M114.511,148.48c-0.14-0.234-0.605-0.234-1.024,0 c-0.419,0.234-0.605,0.608-0.419,0.842c0.14,0.234,0.605,0.234,1.024,0C114.511,149.088,114.697,148.714,114.511,148.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M114.464,148.526c-0.14-0.187-0.558-0.187-0.884,0 c-0.279,0.187-0.465,0.421-0.419,0.655c0-0.187,0.14-0.421,0.419-0.608c0.372-0.187,0.745-0.187,0.884,0 c0,0.047,0.047,0.047,0.047,0.094C114.511,148.62,114.511,148.573,114.464,148.526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B37C2A"
    },
    d: "M118.373,150.679c0.047-0.281-0.326-0.562-0.745-0.655 c-0.465-0.094-0.838,0.047-0.838,0.328c-0.047,0.281,0.326,0.562,0.745,0.655C117.954,151.147,118.326,150.96,118.373,150.679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FEF300"
    },
    d: "M118.373,150.585c0.047-0.281-0.326-0.562-0.745-0.655 c-0.465-0.094-0.838,0.047-0.838,0.328c-0.047,0.281,0.326,0.562,0.745,0.655C117.954,151.053,118.373,150.866,118.373,150.585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D39E1D"
    },
    d: "M118.28,150.585c0-0.234-0.279-0.515-0.698-0.608 c-0.326-0.047-0.652,0-0.745,0.187c0.14-0.14,0.372-0.234,0.698-0.14C118.001,150.117,118.28,150.398,118.28,150.585 c-0.047,0.094-0.047,0.094-0.047,0.14C118.28,150.679,118.28,150.632,118.28,150.585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#605E2F"
    },
    d: "M129.216,135.659c0,3.509,8.097-1.217,8.097-4.82 L129.216,135.659z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EAD395"
    },
    points: "137.313,130.839 129.216,135.705 118.047,129.201  126.145,124.381 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B36A23"
    },
    points: "135.871,130.792 129.123,134.816 119.537,129.248  126.238,125.223 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#934428"
    },
    d: "M121.119,130.137c1.954-0.421,5.072-2.901,5.119-4.913 l-6.701,4.024L121.119,130.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#484159"
    },
    d: "M126.284,140.525c0,0.562,0.233,1.076,0.558,1.076 c0.326,0,0.558-0.468,0.558-1.076c0-0.608-0.233-1.076-0.558-1.076C126.563,139.496,126.284,139.963,126.284,140.525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5B5674"
    },
    d: "M126.424,140.619c0,0.562,0.233,1.076,0.558,1.076 c0.326,0,0.558-0.468,0.558-1.076c0-0.562-0.233-1.076-0.558-1.076C126.656,139.542,126.424,140.01,126.424,140.619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#736F90"
    },
    d: "M127.215,141.087c-0.279,0-0.512-0.234-0.512-0.515 c0-0.281,0.233-0.515,0.512-0.515c0.279,0,0.512,0.234,0.512,0.515C127.727,140.853,127.494,141.087,127.215,141.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M127.354,140.151c-0.093-0.047-0.186,0-0.233,0.047 c-0.047,0.047,0.046,0.14,0.14,0.187c0.093,0.047,0.186,0,0.233-0.047C127.494,140.291,127.447,140.198,127.354,140.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#1D1D1B"
    },
    d: "M126.982,140.946c-0.14,0-0.233-0.094-0.233-0.234 c0-0.14,0.093-0.234,0.233-0.234s0.233,0.094,0.233,0.234C127.215,140.806,127.122,140.946,126.982,140.946z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#484159"
    },
    cx: 122.701,
    cy: 143.005,
    rx: 0.558,
    ry: 1.076
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5B5674"
    },
    d: "M122.282,143.052c0,0.562,0.233,1.076,0.558,1.076 c0.326,0,0.558-0.468,0.558-1.076c0-0.562-0.233-1.076-0.558-1.076C122.561,142.023,122.282,142.491,122.282,143.052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B354A"
    },
    d: "M123.957,143.052v0.842l2.42-1.451v-0.842L123.957,143.052z M123.492,145.251 c-0.093,0-0.186,0-0.233-0.047c-0.14-0.094-0.233-0.234-0.233-0.421v-1.965c0-0.187,0.093-0.328,0.233-0.421l3.397-2.012 c0.14-0.094,0.326-0.094,0.465,0c0.14,0.094,0.233,0.234,0.233,0.421v1.965c0,0.187-0.093,0.328-0.233,0.421l-3.397,2.012 C123.631,145.204,123.585,145.251,123.492,145.251z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#736F90"
    },
    cx: 123.073,
    cy: 143.051,
    rx: 0.512,
    ry: 0.515
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M123.213,142.631c-0.093-0.047-0.186,0-0.233,0.047 c-0.047,0.047,0.047,0.14,0.14,0.187c0.093,0.047,0.186,0,0.233-0.047C123.352,142.725,123.306,142.678,123.213,142.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#1D1D1B"
    },
    d: "M122.84,143.379c-0.14,0-0.233-0.094-0.233-0.234 s0.093-0.234,0.233-0.234s0.233,0.094,0.233,0.234S122.98,143.379,122.84,143.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#484159"
    },
    d: "M122.841,143.332c-0.093,0-0.186-0.094-0.186-0.187 c0-0.094,0.093-0.187,0.186-0.187c0.093,0,0.186,0.094,0.186,0.187C123.027,143.239,122.934,143.332,122.841,143.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5B5674"
    },
    d: "M116.232,141.461c0,0.889-0.326,1.544-0.791,1.451 c-0.465-0.047-0.838-0.842-0.884-1.731c0-0.889,0.326-1.544,0.791-1.451C115.814,139.823,116.186,140.572,116.232,141.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#736F90"
    },
    d: "M116.046,141.555c0,0.889-0.326,1.544-0.791,1.451 c-0.465-0.047-0.838-0.842-0.884-1.731c0-0.889,0.326-1.544,0.791-1.451C115.627,139.87,116,140.666,116.046,141.555z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#484159"
    },
    points: "128.983,135.846 120.886,140.665 120.886,142.21  128.983,137.343 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5B5674"
    },
    points: "109.671,134.208 120.886,140.665 120.886,142.209  109.671,135.705 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#484159"
    },
    d: "M129.868,136.782l6.841-4.071 c0.372-0.608,0.605-1.263,0.605-1.872l-8.097,4.82C129.216,136.267,129.495,136.641,129.868,136.782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484159"
    },
    d: "M114.929,140.992l-0.186,0.14c-0.047,0.047-0.14,0.187-0.186,0.515c0,0.187,0,0.374,0,0.468 l0.372-0.234V140.992z M114.464,142.864c-0.186,0-0.326-0.094-0.465-0.281c-0.279-0.468-0.186-1.731,0.372-2.059l0.698-0.421 c0.093-0.047,0.233-0.047,0.326,0s0.186,0.187,0.186,0.281v1.685c0,0.14-0.047,0.234-0.186,0.281l-0.698,0.421 C114.65,142.864,114.557,142.864,114.464,142.864z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    points: "109.671,141.46 110.09,141.226 110.09,141.46  120.886,147.73 122.049,147.964 120.886,149.228 109.671,142.724 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#736F90"
    },
    points: "128.983,143.239 128.611,143.005 128.611,143.286  120.886,147.684 122.375,148.199 128.983,144.502 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#484159"
    },
    points: "128.983,143.238 120.886,147.918 120.886,149.462  128.983,144.736 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5B5674"
    },
    points: "109.671,141.461 120.886,147.918 120.886,149.462  109.671,142.958 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M120.421,140.993c0,0.281-0.14,0.468-0.326,0.468 s-0.372-0.281-0.372-0.562s0.14-0.468,0.326-0.468C120.235,140.478,120.421,140.712,120.421,140.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DADDE5"
    },
    d: "M120.048,140.711c-0.047,0.094-0.093,0.187-0.186,0.14 c-0.047,0-0.093-0.094-0.093-0.187c0.046-0.094,0.093-0.187,0.186-0.14C120.048,140.524,120.095,140.618,120.048,140.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#736F90"
    },
    d: "M121.724,140.759c0,0.281,0.14,0.468,0.326,0.468 c0.186,0,0.372-0.281,0.372-0.562c0-0.281-0.14-0.468-0.326-0.468C121.91,140.244,121.724,140.478,121.724,140.759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M122.05,140.478c0.046,0.094,0.093,0.187,0.186,0.14 c0.047,0,0.093-0.094,0.093-0.187c-0.047-0.094-0.093-0.187-0.186-0.14C122.05,140.291,122.05,140.385,122.05,140.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M118.047,139.589c0,0.281-0.14,0.468-0.326,0.468 s-0.372-0.281-0.372-0.562c0-0.281,0.14-0.468,0.326-0.468C117.861,139.074,118.001,139.308,118.047,139.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DADDE5"
    },
    d: "M117.675,139.308c-0.047,0.094-0.093,0.187-0.186,0.14 c-0.047,0-0.093-0.094-0.093-0.187c0.046-0.094,0.093-0.187,0.186-0.14C117.675,139.121,117.722,139.215,117.675,139.308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M115.627,138.232c0,0.281-0.14,0.468-0.326,0.468 c-0.186,0-0.372-0.281-0.372-0.562c0-0.281,0.14-0.468,0.326-0.468C115.488,137.717,115.627,137.951,115.627,138.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DADDE5"
    },
    d: "M115.302,137.951c-0.047,0.094-0.093,0.187-0.186,0.14 c-0.046,0-0.093-0.094-0.093-0.187c0.046-0.094,0.093-0.187,0.186-0.14C115.302,137.764,115.348,137.857,115.302,137.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M113.254,136.828c0,0.281-0.14,0.468-0.326,0.468 c-0.186,0-0.372-0.281-0.372-0.561c0-0.281,0.14-0.468,0.326-0.468C113.115,136.313,113.254,136.547,113.254,136.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DADDE5"
    },
    d: "M112.929,136.547c-0.047,0.094-0.093,0.187-0.186,0.14 c-0.047,0-0.093-0.094-0.093-0.187c0.046-0.094,0.093-0.187,0.186-0.14C112.929,136.36,112.975,136.453,112.929,136.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M110.881,135.471c0,0.281-0.14,0.468-0.326,0.468 s-0.372-0.281-0.372-0.562c0-0.281,0.14-0.468,0.326-0.468C110.695,134.957,110.881,135.191,110.881,135.471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DADDE5"
    },
    d: "M110.555,135.19c-0.047,0.094-0.093,0.187-0.186,0.14 c-0.047,0-0.093-0.094-0.093-0.187c0.046-0.094,0.093-0.187,0.186-0.14C110.555,135.003,110.555,135.096,110.555,135.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M120.421,148.245c0,0.281-0.14,0.468-0.326,0.468 s-0.372-0.281-0.372-0.562c0-0.281,0.14-0.468,0.326-0.468C120.235,147.73,120.421,147.964,120.421,148.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DADDE5"
    },
    d: "M120.048,147.964c-0.047,0.094-0.093,0.187-0.186,0.14 c-0.047,0-0.093-0.094-0.093-0.187c0.046-0.094,0.093-0.187,0.186-0.14C120.048,147.777,120.095,147.87,120.048,147.964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M118.047,146.841c0,0.281-0.14,0.468-0.326,0.468 s-0.372-0.281-0.372-0.562c0-0.281,0.14-0.468,0.326-0.468C117.861,146.327,118.001,146.561,118.047,146.841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DADDE5"
    },
    d: "M117.675,146.561c-0.047,0.094-0.093,0.187-0.186,0.14 c-0.047,0-0.093-0.094-0.093-0.187c0.046-0.094,0.093-0.187,0.186-0.14C117.675,146.374,117.722,146.467,117.675,146.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M115.627,145.485c0,0.281-0.14,0.468-0.326,0.468 c-0.186,0-0.372-0.281-0.372-0.562s0.14-0.468,0.326-0.468C115.488,144.97,115.627,145.204,115.627,145.485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DADDE5"
    },
    d: "M115.302,145.204c-0.047,0.094-0.093,0.187-0.186,0.14 c-0.046,0-0.093-0.094-0.093-0.187c0.046-0.094,0.093-0.187,0.186-0.14C115.302,145.017,115.348,145.11,115.302,145.204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M113.254,144.081c0,0.281-0.14,0.468-0.326,0.468 c-0.186,0-0.372-0.281-0.372-0.562c0-0.281,0.14-0.468,0.326-0.468C113.115,143.566,113.254,143.8,113.254,144.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DADDE5"
    },
    d: "M112.929,143.8c-0.047,0.094-0.093,0.187-0.186,0.14 c-0.047,0-0.093-0.094-0.093-0.187c0.046-0.094,0.093-0.187,0.186-0.14C112.929,143.612,112.975,143.706,112.929,143.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M110.881,142.724c0,0.281-0.14,0.468-0.326,0.468 s-0.372-0.281-0.372-0.562c0-0.281,0.14-0.468,0.326-0.468C110.695,142.209,110.881,142.443,110.881,142.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DADDE5"
    },
    d: "M110.555,142.443c-0.047,0.094-0.093,0.187-0.186,0.14 c-0.047,0-0.093-0.094-0.093-0.187c0.046-0.094,0.093-0.187,0.186-0.14C110.555,142.255,110.555,142.349,110.555,142.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#736F90"
    },
    d: "M123.725,139.589c0,0.281,0.14,0.468,0.326,0.468 s0.372-0.281,0.372-0.562c0-0.281-0.14-0.468-0.326-0.468C123.865,139.028,123.725,139.308,123.725,139.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M124.051,139.308c0.047,0.094,0.093,0.187,0.186,0.14 c0.047,0,0.093-0.094,0.093-0.187c-0.047-0.094-0.093-0.187-0.186-0.14C124.051,139.121,124.004,139.168,124.051,139.308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#736F90"
    },
    d: "M125.679,138.372c0,0.281,0.14,0.468,0.326,0.468 s0.372-0.281,0.372-0.562c0-0.281-0.14-0.468-0.326-0.468C125.865,137.857,125.726,138.091,125.679,138.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M126.052,138.091c0.047,0.094,0.093,0.187,0.186,0.14 c0.047,0,0.093-0.094,0.093-0.187c-0.047-0.094-0.093-0.187-0.186-0.14C126.052,137.903,126.005,137.997,126.052,138.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#736F90"
    },
    d: "M127.681,137.203c0,0.281,0.14,0.468,0.326,0.468 c0.186,0,0.372-0.281,0.372-0.562c0-0.281-0.14-0.468-0.326-0.468C127.867,136.641,127.681,136.922,127.681,137.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M128.053,136.921c0.047,0.094,0.093,0.187,0.186,0.14 c0.047,0,0.093-0.094,0.093-0.187c-0.047-0.094-0.093-0.187-0.186-0.14C128.053,136.734,128.007,136.781,128.053,136.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#736F90"
    },
    d: "M121.724,148.058c0,0.281,0.14,0.468,0.326,0.468 c0.186,0,0.372-0.281,0.372-0.562c0-0.281-0.14-0.468-0.326-0.468C121.91,147.543,121.724,147.777,121.724,148.058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M122.05,147.777c0.046,0.094,0.093,0.187,0.186,0.14 c0.047,0,0.093-0.094,0.093-0.187c-0.047-0.094-0.093-0.187-0.186-0.14C122.05,147.59,122.05,147.683,122.05,147.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#736F90"
    },
    d: "M123.725,146.888c0,0.281,0.14,0.468,0.326,0.468 s0.372-0.281,0.372-0.562c0-0.281-0.14-0.468-0.326-0.468C123.865,146.374,123.725,146.608,123.725,146.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M124.051,146.607c0.047,0.094,0.093,0.187,0.186,0.14 c0.047,0,0.093-0.094,0.093-0.187c-0.047-0.094-0.093-0.187-0.186-0.14C124.051,146.42,124.004,146.467,124.051,146.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#736F90"
    },
    d: "M125.679,145.672c0,0.281,0.14,0.468,0.326,0.468 s0.372-0.281,0.372-0.562c0-0.281-0.14-0.468-0.326-0.468C125.865,145.157,125.726,145.391,125.679,145.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M126.052,145.391c0.047,0.094,0.093,0.187,0.186,0.14 c0.047,0,0.093-0.094,0.093-0.187c-0.047-0.094-0.093-0.187-0.186-0.14C126.052,145.203,126.005,145.297,126.052,145.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#736F90"
    },
    d: "M127.681,144.503c0,0.281,0.14,0.468,0.326,0.468 c0.186,0,0.372-0.281,0.372-0.562c0-0.281-0.14-0.468-0.326-0.468C127.867,143.988,127.681,144.222,127.681,144.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M128.053,144.221c0.047,0.094,0.093,0.187,0.186,0.14 c0.047,0,0.093-0.094,0.093-0.187c-0.047-0.094-0.093-0.187-0.186-0.14C128.053,144.034,128.007,144.081,128.053,144.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#736F90"
    },
    d: "M130.007,135.798c0,0.281,0.14,0.468,0.326,0.468 s0.372-0.281,0.372-0.562c0-0.281-0.14-0.468-0.326-0.468C130.193,135.284,130.007,135.518,130.007,135.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M130.333,135.517c0.046,0.094,0.093,0.187,0.186,0.14 c0.047,0,0.093-0.094,0.093-0.187c-0.047-0.094-0.093-0.187-0.186-0.14C130.333,135.33,130.333,135.424,130.333,135.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#736F90"
    },
    d: "M132.008,134.629c0,0.281,0.14,0.468,0.326,0.468 c0.186,0,0.372-0.281,0.372-0.562c0-0.281-0.14-0.468-0.326-0.468C132.147,134.067,132.008,134.348,132.008,134.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M132.333,134.301c0.046,0.094,0.093,0.187,0.186,0.14 c0.047,0,0.093-0.094,0.093-0.187c-0.047-0.094-0.093-0.187-0.186-0.14C132.333,134.161,132.333,134.208,132.333,134.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#736F90"
    },
    d: "M133.962,133.412c0,0.281,0.14,0.468,0.326,0.468 s0.372-0.281,0.372-0.562c0-0.281-0.14-0.468-0.326-0.468C134.149,132.897,134.009,133.131,133.962,133.412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M134.335,133.131c0.047,0.094,0.093,0.187,0.186,0.14 c0.046,0,0.093-0.094,0.093-0.187c-0.047-0.094-0.093-0.187-0.186-0.14C134.335,132.943,134.289,133.037,134.335,133.131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#736F90"
    },
    d: "M135.964,132.243c0,0.281,0.14,0.468,0.326,0.468 c0.186,0,0.372-0.281,0.372-0.562c0-0.281-0.14-0.468-0.326-0.468C136.15,131.681,135.964,131.962,135.964,132.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6ABCC"
    },
    d: "M136.336,131.915c0.047,0.094,0.093,0.187,0.186,0.14 c0.047,0,0.093-0.094,0.093-0.187c-0.047-0.094-0.093-0.187-0.186-0.14C136.336,131.775,136.29,131.822,136.336,131.915z"
  }), /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_65_",
    d: "M292.459,0H27.97C13.429,0,2.022,11.857,2.49,26.405l6.415,199.548C9.333,239.264,20.868,250,34.672,250 h251.084c13.804,0,25.339-10.736,25.767-24.047l6.415-199.548C318.406,11.857,307,0,292.459,0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_66_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_65_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: -71.8497,
    y1: 52.7256,
    x2: -73.2924,
    y2: 205.6537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0012,
    style: {
      stopColor: "#AC42E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#6A23C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_66_)",
      fill: "url(#SVGID_67_)"
    },
    d: "M18.151,177.661h-181.095c-10.535,0-19.075-8.54-19.075-19.075 V62.71c0-10.535,8.54-19.075,19.075-19.075H18.151c10.535,0,19.075,8.54,19.075,19.075v95.876 C37.227,169.121,28.686,177.661,18.151,177.661z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.0611,
    y1: 52.7256,
    x2: 393.6184,
    y2: 205.6537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0012,
    style: {
      stopColor: "#EF62D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CB2BBF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_66_)",
      fill: "url(#SVGID_68_)"
    },
    d: "M485.062,177.661H303.967c-10.535,0-19.075-8.54-19.075-19.075 V62.71c0-10.535,8.54-19.075,19.075-19.075h181.095c10.535,0,19.075,8.54,19.075,19.075v95.876 C504.138,169.121,495.597,177.661,485.062,177.661z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M170.56,220.606c0,0,7.075,13.551,17.124,6.936c10.033-6.633,14.441-8.833,10.565-18.445 C194.389,199.503,170.56,220.606,170.56,220.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0C3D"
    },
    d: "M197.654,209.349c3.669,9.135-0.376,11.072-10.324,17.659c-6.292,4.149-12.163,0.121-15.93-6.242 C177.362,215.619,194.702,202.03,197.654,209.349z M169.736,220.464c4.019,7.557,11.009,12.44,18.284,7.627 c10.051-6.649,14.904-9.092,10.824-19.246C195.251,199.863,177.03,214.056,169.736,220.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M182.361,173.774c-7.463-0.385-7.305,2.567-7.305,2.567s-4.575-3.395-10.909,1.549 c-0.886,0.703-1.424,1.756-1.418,2.887l-0.002,0.033c-1.141-1.372-2.253-2.96-3.304-4.76c-2.346-4.012-4.131-8.278-6-12.498 c-0.653-1.464-1.574-2.908-3.015-3.631c-1.085-0.538-2.313-0.601-3.514-0.53c-1.468,0.091-2.947,0.38-4.248,1.078 c-2.003,1.077-3.475,3.097-3.894,5.336c-0.902,5.042,4.228,10.494,7.163,14.071c2.904,3.542,5.431,6.033,8.492,9.434 c3.909,4.342,5.124,9.909,5.353,12.165c-0.488,1.039-0.606,0.767-1.324,1.129c-4.888,2.475-10.884-3.587-18.89,0.905 c-8.022,4.475-8.734,12.503-5.659,14.092c3.075,1.589,8.381-5.903,13.119-3.065c4.544,2.729,25.194,15.233,35.494,7.351 c1.197-0.919,2.393-1.839,3.637-2.706c3.819-2.68,11.007-8.362,11.277-13.403C197.748,198.878,189.808,174.142,182.361,173.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0C3D"
    },
    d: "M196.866,205.733c-0.296,5.539-10.101,12.566-14.676,15.705c-10.906,8.334-34.094-7.096-34.894-7.386 c-4.996-2.985-10.513,4.413-13.134,3.048c-2.703-1.386-1.901-8.928,5.659-13.144c8.125-4.536,15.514,2.829,19.63-1.066 c0.683-0.647,1-1.595,0.851-2.534c-1.49-8.823-6.371-11.785-14.861-21.884c-2.923-3.493-6.941-8.273-6.178-12.59 c0.377-2.076,1.742-3.967,3.607-4.952c1.951-1.03,5.45-1.465,7.279-0.523c1.895,0.946,2.691,3.165,3.566,5.156 c5.161,11.706,6.25,12.494,9.547,16.755c0.109-0.793-0.453-2.717,1.194-3.979c5.901-4.618,10.083-1.658,10.259-1.533l0.926,0.713 c-0.027-1.049-0.243-1.359,0.405-1.975c0.561-0.536,2.121-1.404,6.267-1.19C189.265,174.662,197.216,198.884,196.866,205.733z  M182.419,173.312c-2.521-0.13-6.603,0.009-7.655,2.282c-4.829-2.377-11.34,0.895-12.32,3.987 c-8.908-11.617-6.766-21.184-15.541-20.672c-5.189,0.314-8.012,3.361-8.632,6.855c-0.856,4.811,3.333,9.816,6.397,13.466 c8.661,10.324,13.538,15.214,14.494,21.582c0.095,0.703-0.258,1.4-0.921,1.682l-0.017,0.016c-4.733,2.051-10.714-3.961-18.907,0.605 c-8.434,4.72-9.122,13.231-5.627,15.041c1.602,0.831,3.558-0.299,5.602-1.507c6.284-3.7,7.129-1.462,7.628-1.469 c27.201,16.268,34.48,7.664,36.142,7.051c4.682-3.583,14.565-9.891,14.893-16.343C198.371,198.727,190.313,173.719,182.419,173.312z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0C3D"
    },
    d: "M166.471,190.099c-3.793-8.676-5.046-9.822-4.108-10.256 C163.369,179.38,163.305,181.521,166.471,190.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0C3D"
    },
    d: "M182.407,188.16c-3.518-10.092-8.893-10.968-7.762-12.207 C175.74,174.746,180.624,181.367,182.407,188.16z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondStep);
export default __webpack_public_path__ + "static/media/second_step.fe3c6650b106641f216cf7a4b8f001e5.svg";
export { ForwardRef as ReactComponent };